window.Branch = window.Branch || {};
window.Branch.product = window.Branch.product || {};
window.Branch.product._cdnBase = window.location.hostname.includes('branchfurniture.ca')
    ? 'https://www.branchfurniture.ca/cdn/shop/'
    : 'https://www.branchfurniture.com/cdn/shop/';

window.Branch.product.normalizeImageUrl = function(url) {
    if(url.startsWith('files/')){
        return window.Branch.product._cdnBase + url.replace('&', '?');
    } else if(url.startsWith('//')){
        return 'https:' + url;
    }
    return url;
};

const openCloseAccordionSlides = function(e){
    let parents = document.querySelectorAll('.main-product__accordion');
    if(e){
        let closest = e.target.closest('.main-product__accordion');
        closest.setAttribute('accordion-select', '');
        parents = document.querySelectorAll('.main-product__accordion[accordion-select]');
        closest.removeAttribute('accordion-select')
    }
    parents.forEach((parent) => {
        let openSlides = parent.querySelectorAll('.main-product__accordion-li[data-status="open"]');
        let ul = parent.querySelector('.main-product__accordion-ul');

        ul.setAttribute('data-transitioning', 'true')

        let liElement;
        let newStatus;
        if(e && e.target){
            liElement = e.target.closest('.main-product__accordion-li') ? e.target.closest('.main-product__accordion-li') : e.target;
            newStatus = liElement.getAttribute('data-status') == 'open' ? 'closed' : 'open';
        }

        let timeoutLength = openSlides.length > 0 && newStatus == "open" ? 1000 : 500;

        if(openSlides.length > 0){
            openSlides.forEach((openSlide) => {
                openSlide.setAttribute("data-status", 'closed');
                openSlide.querySelector('.main-product__accordion-body-container').style.height = "0"            
            })
        }

        const openSlide = function(){
            liElement.setAttribute('data-status', 'open');
            let liBody = liElement.querySelector('.main-product__accordion-body-container');
            let bodyHeight = parseFloat(window.Branch.functions.getStyle(liBody.querySelector('.main-product__accordion-body-inner-container'), 'height').replace('px', ''));
            liBody.style.height = `${bodyHeight}px`
        }

        setTimeout(() => {
            ul.setAttribute('data-transitioning', 'false')
        }, `${timeoutLength}`);


        if(newStatus == 'open' && e && e.target){
            if(openSlides.length > 0){ 
                setTimeout(() => {
                openSlide()
                }, "500");
            } else {
                openSlide()
            }
        }
    })
}

window.Branch = window.Branch || {};
window.Branch.product = window.Branch.product || {};

window.Branch.product.updateDiscountCodePrice = function(variant, product, origin, bundlePricingDataArray, placement) {
    let item = document.querySelector(`#main-product-item-${product.id}`);
    let priceData;

    if(origin == 'bundle-builder-pop-up'){
        priceData = bundlePricingDataArray.find(obj => Object.keys(obj).includes(`${variant.id}`))[`${variant.id}`];

    } else if(placement && placement == 'side-cart'){
        priceData = JSON.parse(document.querySelector(`#full-side-cart-addons-pricing-data`).innerText)[`${product.id}`][`${variant.id}`];

    } else {
        priceData = JSON.parse(document.querySelector(`.per-variant-pricing[data-product-handle="${product.handle}"]`).innerText)[`${variant.id}`];
    }
    let originalPrice = priceData.opx == "" ? null : priceData.opx;
    let currentPrice = priceData.cpx;
    let discountMessage = priceData.dcmx == "" ? null : priceData.dcmx;

    if(origin == 'bundle-builder-pop-up'){
        let discount_multiplier = ((100 - parseInt(priceData.bdx))/100);
        originalPrice = priceData.opx == "" ? priceData.cpx : priceData.opx;
        currentPrice = priceData.cpx * discount_multiplier;
    }

    if(originalPrice == currentPrice){
        originalPrice = null;
    }

    let priceContainers = item.querySelectorAll('.main-product .main-product__title-review-price-container .price');
    if(priceContainers.length > 0){
        priceContainers.forEach((priceContainer) => {
            let priceParent = priceContainer.parentElement;
            priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"])  [data-price="deal"]').innerHTML = Shopify.formatMoney(currentPrice, Simplistic.formatMoney).split('.')[0].replace(' ','');
        
            let retail = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) .retail');
            let dataRetail = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="retail"]');
            let offPecentage = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-percent"]');
            let offAmount = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-amount"]');
            let discountCodeOffPercent = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="discount-code-off-percent"]');
        
            if(originalPrice != null){
              var retailPrice = Shopify.formatMoney(originalPrice, Simplistic.formatMoney).replace('.00', '').replace(' ','');
              var percentDiscount = Math.round( (((originalPrice - currentPrice) * 100 ) / originalPrice) );
              var moneyDiscount = Shopify.formatMoney((originalPrice - currentPrice), Simplistic.formatMoney).replace('.00', '').replace(' ','');
                  
              
        
              if(discountMessage && discountMessage != null && discountCodeOffPercent){
                var modifiedMessage = discountMessage.replace('<p>',`<p>Save ${percentDiscount}% `)
                discountCodeOffPercent.innerHTML = modifiedMessage;
              }
        
              if(dataRetail){
                dataRetail.innerHTML = `${retailPrice}`;
            };

              if(retail){retail.setAttribute('data-visible', true)};
              if(offPecentage){offPecentage.innerHTML = `${percentDiscount}%`};
              if(offAmount){offAmount.innerHTML = moneyDiscount};
        
            } else {
                if(dataRetail){dataRetail.innerHTML = ''};
                if(retail){retail.setAttribute('data-visible', false)};
                if(offPecentage){offPecentage.innerHTML = ''};
                if(offAmount){offAmount.innerHTML = ''};
                if(discountCodeOffPercent){discountCodeOffPercent.innerHTML = ''};
            }
        
        })
    }
  };

window.Branch.product.initAccordion = function(){
    const accordions = document.querySelectorAll('.main-product .main-product__accordion:not([data-init="true"]');
    if(accordions.length > 0){
        accordions.forEach((accordion) => {
            accordion.setAttribute('data-init', true);
            const accordionSlides = accordion.querySelectorAll('.main-product__accordion-li');
            if(accordion && accordionSlides.length > 0){
                accordionSlides.forEach((accordionSlide) => {
                    accordionSlide.querySelector('.main-product__accordion-header-container').addEventListener("click", openCloseAccordionSlides);
                })
            }
        })
    }
}


const returnMaxHeight = function(colorSwatchHeads){
    let maxHeight = 0;
    colorSwatchHeads.forEach((colorSwatchHead) => {
        let colorSwatchHeadHeight = colorSwatchHead.offsetHeight;
        if(colorSwatchHeadHeight > maxHeight){
            maxHeight = colorSwatchHeadHeight;
        }
    })
    return maxHeight;
}

const largestMultipleBelow = function(number, divisor) {
    const remainder = number % divisor;
    return number - remainder;
}

const setCustomContainerWidth = function(colorSwatch){
    let custom_option_present = colorSwatch.closest('.swatches-container[data-custom-color-swatch-options="true"]') ? true : false;
    if(custom_option_present){
        let colorCustomSwatchContainers = colorSwatch.querySelectorAll('.custom-color-swatch-option__new-swatch-container, .custom-color-swatch-option__regular-swatch-container');

        colorCustomSwatchContainers.forEach((colorCustomSwatchContainer) => {
            colorCustomSwatchContainer.style.width = 'unset'
            setTimeout(() => {
                // Cap the natural width by the actual usable content area of the
                // surrounding .swatch-tab-inner. When the tab is scrollable, the
                // vertical scrollbar (plus our reserved padding-right) eats into
                // that area — without this, the container is sized wide enough
                // to fit a swatch under the scrollbar.
                let usableWidth = colorCustomSwatchContainer.offsetWidth;
                const inner = colorCustomSwatchContainer.closest('.swatch-tab-inner');
                if(inner){
                    const innerCS = getComputedStyle(inner);
                    const innerContent = inner.clientWidth - parseFloat(innerCS.paddingLeft) - parseFloat(innerCS.paddingRight);
                    if(innerContent > 0 && innerContent < usableWidth){
                        usableWidth = innerContent;
                    }
                }
                // 71 = current swatch width (54) + column-gap (17); produces container
                // widths that fit exactly N swatches per row, so 5 still fit when there's
                // actually room and don't get squeezed down to 4 unnecessarily.
                const finalNumber = largestMultipleBelow(usableWidth + 17, 71)
                colorCustomSwatchContainer.style.width = `${finalNumber - 17}px`
            }, 250)
        })

    }
}

window.Branch.product.customSwatchContainerResize = function(selector){
    let colorSwatches = document.querySelectorAll(`${selector} .swatches-container .swatches-container__color-swatches-container`);
    if(colorSwatches.length > 0){
        colorSwatches.forEach((colorSwatch) => {
            setCustomContainerWidth(colorSwatch);
        })
    }
}

window.Branch.product.initPreOrderSwatch = function(discountMessage, discountAmount, preOrderSwatches, productId, defaultCodeMessage, hidePdpBadgeMessage, overridePdpTooltip, pdpTooltipHtml, productHandle, activeCampaignPromoStylingEnabled, activeCampaignSwatchColorEnabled, isBundleBuilder){
    let displayPreorderSwatch = discountMessage == "" ? false : true;
    let discountMessageFull = '';
    let discountMessageMobile = ''
    let toolTipText = '';
    let useHtmlTooltip = overridePdpTooltip && pdpTooltipHtml;

    // Merchandize the pre-order swatch for applicable products even when the price isn't
    // changed (e.g. a campaign with disable_strike_through_pricing): if the campaign
    // specifies a pre-order swatch label override for this eligible product, show the
    // swatch regardless of whether a discount message exists.
    let campaignPreOrderMessageOverride = window.Branch.functions.returnSalesTagText(productHandle, 'fromHandle', 'pre-order-swatch');
    if(displayPreorderSwatch == false && campaignPreOrderMessageOverride != null && campaignPreOrderMessageOverride !== '' && isBundleBuilder == false){
        displayPreorderSwatch = true;
    }

    if(isBundleBuilder){
        discountAmount = discountAmount + 5;
    }

    if(discountMessage != ""){
        if(hidePdpBadgeMessage){
            discountMessageFull = `<p>Save ${discountAmount}%</p>`;
            discountMessageMobile = `Save ${discountAmount}%`;
        } else if (isBundleBuilder == false) {
            discountMessageFull = discountMessage.replace('<p>', `<p>Save ${discountAmount}% `);
            discountMessageMobile = discountMessage.replace('with code', 'Code');
        } else {
            discountMessageFull = `<p>Save ${discountAmount}%</p>`;
            discountMessageMobile = `Save ${discountAmount}%`;
        }
        toolTipText = defaultCodeMessage;
    }

    let preOrderSwatchData =  document.querySelector(`.pre-order-swatch-data[data-product-id="${productId}"]`) ? JSON.parse(document.querySelector(`.pre-order-swatch-data[data-product-id="${productId}"]`).innerText) : {};
    if(preOrderSwatchData && preOrderSwatchData['variant_level']){
        if(preOrderSwatchData['swatch_text'] && preOrderSwatchData['tooltip_text']){
            discountMessageFull = preOrderSwatchData['swatch_text'];
            discountMessageMobile = preOrderSwatchData['swatch_text'];
            if(discountMessageMobile.includes('% with code')){
                discountMessageMobile = `Code ${discountMessageMobile.split('with code ')[1]}`;
            } else if(discountMessageMobile.includes('% with ')){
                discountMessageMobile = `Code ${discountMessageMobile.split('with ')[1]}`;
            }
            toolTipText = preOrderSwatchData['tooltip_text'];
            displayPreorderSwatch = true;
        };
    };

    if(preOrderSwatches.length > 0 && displayPreorderSwatch == true){
        // Campaign label override wins (PDP only — the bundle builder shows its own "Save N%").
        if (campaignPreOrderMessageOverride != null && campaignPreOrderMessageOverride !== '' && isBundleBuilder == false) {
            discountMessageFull = campaignPreOrderMessageOverride;
            discountMessageMobile = campaignPreOrderMessageOverride;
        }

        preOrderSwatches.forEach((preOrderSwatch) => {
            window.Branch.functions.renderPreOrderSwatch(preOrderSwatch, {
                messageDesktop: discountMessageFull,
                messageMobile: discountMessageMobile,
                tooltipText: toolTipText,
                useHtmlTooltip: useHtmlTooltip,
                tooltipHtml: pdpTooltipHtml,
                promoStyling: activeCampaignPromoStylingEnabled,
                swatchColor: activeCampaignSwatchColorEnabled,
                // Sentence-case the auto message, but never a merchandized override (authored as-is).
                applySentenceCase: (campaignPreOrderMessageOverride == null || campaignPreOrderMessageOverride == '')
            });
        });
    }
    
}

const bottomRowAddAttribute = function(colorSwatch){
    let lowestElementDistance = 0;
    let elementDistances = [];
    colorSwatch.querySelectorAll('.swatch').forEach((swatchUnit) => {
        let swatchElementsAll = swatchUnit.querySelectorAll('.swatch-element');
        swatchElementsAll.forEach((swatchElement) => {
            swatchElement.setAttribute('bottom-row', false);
            swatchElement.setAttribute('data-element-in-row-has-label', false);
            elementDistances.push(parseInt(swatchElement.getBoundingClientRect().top));
            if(swatchElement.getBoundingClientRect().top > lowestElementDistance) {
                lowestElementDistance = parseInt(swatchElement.getBoundingClientRect().top)
            }
        });

        let uniqelementDistances = [...new Set(elementDistances)];
        uniqelementDistances.forEach((distance) => {
            let distanceHasLabel = false;
            swatchElementsAll.forEach((swatchElement) => {
                if(parseInt(swatchElement.getBoundingClientRect().top) == distance) {
                    if(swatchElement.getAttribute('data-label') == "true"){
                        distanceHasLabel = true;
                    }
                }
            });

            swatchElementsAll.forEach((swatchElement) => {
                if(parseInt(swatchElement.getBoundingClientRect().top) == lowestElementDistance) {
                    swatchElement.setAttribute('bottom-row', true);
                };

                if(parseInt(swatchElement.getBoundingClientRect().top) == distance) {
                    swatchElement.setAttribute('data-element-in-row-has-label', distanceHasLabel);
                }
            })
        })    
    });
}

function checkElementHeight(colorSwatchHeads, colorSwatch) {
    var element = colorSwatchHeads[0];
    if (element.offsetHeight == 0) {
        setTimeout(function() { 
            checkElementHeight(colorSwatchHeads, colorSwatch);
        }, 500);
    }
}

window.Branch.product.resizeSwatchesHeader = function(parentSelector){
    setTimeout(function(){
        let colorSwatches = document.querySelectorAll(`${parentSelector} .swatches-container .swatches-container__color-swatches-container`);
        if(colorSwatches.length > 0){
            colorSwatches.forEach((colorSwatch) => {
                let colorSwatchHeads = colorSwatch.querySelectorAll('.swatch .head ');
                if(colorSwatchHeads.length > 1){
                    checkElementHeight(colorSwatchHeads, colorSwatch);
                }
                bottomRowAddAttribute(colorSwatch);
            })
        }
    },
    500)
  }

  window.Branch.product.formatSwatches = function(format_options){
   
    if(!format_options){
        format_options = {};

        format_options['swatches_selector'] = `.main-product .swatches-container__color-swatches-container`;
        format_options['swatches_container_parent_selector'] = '.swatches-container'
        format_options['swatch_width'] = 47;
        format_options['divider_width'] = 41;
    }

    const swatches = document.querySelectorAll(`${format_options.swatches_selector}`);
        swatches.forEach((swatch) => {
    swatch.removeAttribute('data-wrapped');
      let isQuickView = swatch.closest('.main-product[data-quick-view="true"]') ? true : false;
      let buttonWidth = 0
      if(format_options.not_hidden_button_container != null && swatch.closest(`${format_options.swatches_container_parent_selector}`).querySelectorAll(`${format_options.not_hidden_button_container}`).length > 0){
        buttonWidth = swatch.closest(`${format_options.swatches_container_parent_selector}`).querySelector(`${format_options.not_hidden_button_container}`).offsetWidth + 10;
      }
      if(format_options['button_width'] == 0){
        buttonWidth = 0;
      }
      let width = swatch.closest(`${format_options.swatches_container_parent_selector}`).offsetWidth - buttonWidth;
      if(isQuickView == true){
        let currentWindowWidth = window.Branch.functions.returnWindowWidth();
        width = currentWindowWidth >= 900 ? ((currentWindowWidth - 34) * 0.55) - 40 - 24 : currentWindowWidth - 80;
        if(currentWindowWidth >= 1014){
            width = (980 * 0.55) - 40 - 24;
        }
      }
      
      let numberOfSwatches = swatch.querySelectorAll('.swatch-element.color').length;
      
      if(numberOfSwatches > 0){
        let swatchWidth = 69;

        let dividerWidth = format_options.divider_width;
        let customSwatchUnits = swatch.querySelectorAll('.swatch.color[role="group"] .custom-color-swatch-option');  
        let widthNeededToBeOnOneLine = dividerWidth + (numberOfSwatches * swatchWidth);

        if(width > widthNeededToBeOnOneLine){
          swatch.setAttribute('data-wrapped', false)
        } else {
          swatch.setAttribute('data-wrapped', true)
        }

        if(customSwatchUnits.length > 0 && !swatch.closest('.main-product') && !swatch.closest('.variant-inspect')){
          let customNumberOfSwatches = 0;
          let swatchCustom = swatch.querySelector('.swatch.color[role="group"][data-custom-color-swatch-option="true"]')

          customSwatchUnits.forEach((customSwatchUnit) => {
            customNumberOfSwatches = customNumberOfSwatches + customSwatchUnit.querySelectorAll('.swatch-element.color').length
          })
           let customWidthNeededToBeOnOneLine = dividerWidth + (customNumberOfSwatches * swatchWidth);
           if(width > customWidthNeededToBeOnOneLine){
            swatchCustom.setAttribute('data-wrapped', false)
          } else {
            swatchCustom.setAttribute('data-wrapped', true)
          }
        }
      }


      if(swatch.getAttribute('data-init') == "false"){
        swatch.setAttribute('data-init', 'true');
      }
    });
  }

  window.Branch.product.updateVariantSwatchTitles = function(mainProductSwatches, variant, productId, variantTextReplacementMetafield){
    if(variant){
        mainProductSwatches.forEach((mainProductSwatch, index) => {
            let variantText = variant[`option${index + 1}`];
            if(variantText && variantText != ""){
            let optionVarNameSpans = mainProductSwatch.querySelectorAll('.head span.opt-var-name');
            if(mainProductSwatch.closest('.swatches-container') && mainProductSwatch.closest('.swatches-container__tab-outer-container')){
                optionVarNameSpans = mainProductSwatch.closest('.swatches-container__tab-outer-container').querySelectorAll('.head span.opt-var-name');
            }

            optionVarNameSpans.forEach((optionVarNameSpan) => {
                let variantTextStripped = window.Branch.functions.stripVariantText(variantText, variantTextReplacementMetafield);
                variantTextStripped = variantTextStripped.replace(/ ?inches/gi, "″");
                optionVarNameSpan.classList.add('active')
                let nameSpanText = window.Branch.functions.capitalizeWords(variantTextStripped).replaceAll('Sega', 'SEGA');
                optionVarNameSpan.innerHTML = nameSpanText;

                let optionVarTitleSpan = optionVarNameSpan.parentElement.querySelector('.head span.opt-var-title');
                if(optionVarTitleSpan){
                    let customColorSwatchData = document.querySelector(`#custom-color-swatch-data--${productId}`) ? JSON.parse(document.querySelector(`#custom-color-swatch-data--${productId}`).innerText) : null;
                    if(customColorSwatchData){
                    let variantTextHandleized = variantText.toLowerCase().replaceAll(' ', '-');
                    let variantTitleText = customColorSwatchData[`${variantTextHandleized}`];
                    optionVarTitleSpan.innerHTML = `${variantTitleText}: `;
                    }
                }
            })
            }
        })
    }
  }

  window.Branch.product.updateColorSwatchTabsSelectedIndicator = function(mainProductSwatches, variant, productId) {
    if(variant){
        let mainProductSwatchesIndex = 0;
        mainProductSwatches.forEach((mainProductSwatch, index) => {
            if(mainProductSwatch.closest(`body .swatches-container[data-product-id="${productId}"]`) && mainProductSwatch.classList.contains('color')){
                let colorsSelectedInfoSwatchesContainer = mainProductSwatch.closest('.swatches-container__tab-outer-container').querySelector('.swatches-container__colors_selected-info-swatches-container');
                if(colorsSelectedInfoSwatchesContainer){
                    if(colorsSelectedInfoSwatchesContainer.getAttribute('data-initialized') != 'true'){
                        let firstThreeOptions = Array.from(
                        mainProductSwatch.querySelectorAll('.swatch-element label[role="button"]')
                        )
                        .slice(0, 3)
                        .map(el => {
                            const colorClass = Array.from(el.classList).find(c => c.startsWith('color-'));
                            return colorClass || '';
                        })
                        .filter(Boolean)
                        .join(',');

                        colorsSelectedInfoSwatchesContainer.setAttribute('data-first-three-options', firstThreeOptions);
                    }
                    let firstThreeOptionsArray = colorsSelectedInfoSwatchesContainer.getAttribute('data-first-three-options').split(',');
                    
                    let variantTextHandleized = variant[`option${mainProductSwatchesIndex + 1}`].toLowerCase().replace(/[ /]/g,'-')
                    colorsSelectedInfoSwatchesContainer.querySelectorAll('.swatches-container__colors_selected-info-swatch').forEach((swatch, index)=> {
                        Array.from(swatch.classList).filter(c => c.startsWith('color-')).forEach(c => swatch.classList.remove(c));
                        if(index == 0) {
                            swatch.classList.add(`color-${variantTextHandleized}`);
                            firstThreeOptionsArray = firstThreeOptionsArray.filter(item => item !== `color-${variantTextHandleized}`);
                        } else {
                            swatch.classList.add(`${firstThreeOptionsArray[index - 1]}`);
                        }
                    })

                    if(colorsSelectedInfoSwatchesContainer.getAttribute('data-initialized') != 'true'){
                        colorsSelectedInfoSwatchesContainer.setAttribute('data-initialized', true);
                        if(colorsSelectedInfoSwatchesContainer.closest('.main-product') && colorsSelectedInfoSwatchesContainer.closest('.main-product').getAttribute('data-quick-view') == 'true') {
                            setTimeout(() => {
                            let firstButton = colorsSelectedInfoSwatchesContainer.closest('.main-product').querySelector('.swatches-container .swatches-container__tab-button[data-clickable="true"]:not([data-quick-view-initial-click="true"]):not([data-hide-option-quick-view="true"])');
                            if(firstButton){
                                firstButton.setAttribute('data-quick-view-initial-click', 'true');
                                const clickEvent = new MouseEvent('click', {
                                    bubbles: true,
                                    cancelable: true,
                                    view: window
                                });
                                firstButton.dispatchEvent(clickEvent);
                                if(firstButton.closest('.main-product[data-quick-view="true"]')) {
                                    setTimeout(() => {
                                        let classType = !document.querySelector('body.template-page-bundles') && !document.querySelector('body.template-product-bundle') ? '.main-product[data-quick-view="true"]' : '.bundle-builder__item';      
                                        window.Branch.product.updateSwatchRows(classType);
                                        window.Branch.product.updateSwatchRowsStyling(classType);
                                    }, 1000);
                                }
                            }
                            }, 500);
                        }
                    }
                }
                mainProductSwatchesIndex = mainProductSwatchesIndex + 1;
            }
        })
    }
  }

const initEpigraphButtons = function(){
    let epigraphInstances = document.querySelectorAll('epigraph-ar');
    if(epigraphInstances.length > 0){
        epigraphInstances.forEach((epigraphInstance) => {
            epigraphInstance.addEventListener('click', function(e){
                e.preventDefault();
                e.stopPropagation();
            })
        })
    }
}

const formatReviewsNumber = function(){
    let reviewNumbers = document.querySelectorAll('.main-product .stamped-badge-caption');
    if(reviewNumbers.length > 0){
        reviewNumbers.forEach((reviewNumber) => {
            let numberOfReviews = parseInt(reviewNumber.getAttribute('data-reviews'));
            if(numberOfReviews > 999){
                let number = reviewNumber.childNodes[0];
                let formattedNumber = window.Branch.functions.numberWithCommas(numberOfReviews)
                number.nodeValue = `${formattedNumber}`
            }
        })
    }
}

window.Branch.product.formatPreOrderSwatch = function(id){
    let preOrderSwatches = document.querySelectorAll(`.main-product .pre-order-swatch:not([data-repositioned="true"])`);
    if(id){
        preOrderSwatches = document.querySelectorAll(`.main-product #main-product-item-${id} .pre-order-swatch:not([data-repositioned="true"])`);
    }

    if(preOrderSwatches.length > 0){
        preOrderSwatches.forEach((preOrderSwatch) => {
            let outerPrice = preOrderSwatch.closest('.price');
            let outerPriceWidth = outerPrice.closest('.price-installments-wrapper').offsetWidth; 
            let maxWidth = 0;

            if(outerPrice.querySelector('.price__discount-message')){
                maxWidth = maxWidth + parseInt(outerPrice.querySelector('.price__discount-message').offsetWidth);
            }

            if(outerPrice.querySelector('.retail')){
                maxWidth = maxWidth + parseInt(outerPrice.querySelector('.retail').offsetWidth) + 6;
            }

            if(outerPrice.querySelector('.deal')){
                maxWidth = maxWidth + parseInt(outerPrice.querySelector('.deal').offsetWidth);
            };

            // console.log('maxWidth', maxWidth)

            preOrderSwatch.setAttribute('data-adjusted', true);

            if(outerPriceWidth > 0){
                preOrderSwatch.style.maxWidth = `${outerPriceWidth - maxWidth}px`;
            }

            if(preOrderSwatch.hasAttribute('data-app') && preOrderSwatch.getAttribute('data-app') === 'true'){
                const swatchSpan = preOrderSwatch.querySelector('p > span');
                if(swatchSpan && !swatchSpan.hasAttribute('data-scroll-listener')){
                    swatchSpan.setAttribute('data-scroll-listener', 'true');
                    swatchSpan.style.cursor = 'pointer';
                    swatchSpan.addEventListener('click', function(e){
                        // Check if this click is from a popup/quick view context
                        const isInPopup = e.target.closest('.tingle-modal') ||
                                         e.target.closest('[data-quick-view="true"]') ||
                                         e.target.closest('.main-product[data-quick-view="true"]');

                        if(!isInPopup){
                            const targetSection = document.querySelector('.shopify-section.app-features');
                            if(targetSection){
                                targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }
                        }
                    });
                }
            }
        })
    }
}

function findCheckedRadioIndex(elements) {
    return [...elements].findIndex(element => element.querySelector('input[type="radio"]:checked'));
}

window.Branch.product.returnFirstSecondVariant = function(product, origin, selector){
    let firstSecondVariant = [];
    let option_number = 1;
    let firstVariant = product.variants[0];
    let secondVariant;
    let secondSwatchIndex;
    let secondSwatchValue;
    let firstVariantSiblingSwatches;

    // console.log('returnFirstSecondVariant', product, origin, selector)

    if(origin == "main-product") {
        firstVariantSiblingSwatches = document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container.options .swatch`)[0].querySelectorAll('.swatch-element');
    } else if(origin == "tile"){
        firstVariantSiblingSwatches = document.querySelector(`${selector}`) && document.querySelector(`${selector}`).querySelectorAll('.swatches-container .swatch')[0] ? document.querySelector(`${selector}`).querySelectorAll('.swatches-container .swatch')[0].querySelectorAll('.swatch-element') : null;
    } else {
        firstVariantSiblingSwatches = document.querySelector(`${selector}`).querySelectorAll('.swatches-container .swatch')[0].querySelectorAll('.swatch-element');
    }
    if(firstVariantSiblingSwatches){
        let checkedInputIndex = origin == "main-product" ? [...firstVariantSiblingSwatches].findIndex(element => element.querySelector('input[type="radio"]:checked')) : [...firstVariantSiblingSwatches].findIndex(element => element.classList.contains('selected'));
        
        if((checkedInputIndex + 1) < firstVariantSiblingSwatches.length){
            secondSwatchIndex = checkedInputIndex + 1;
            secondSwatchValue = firstVariantSiblingSwatches[secondSwatchIndex].getAttribute('data-value');
        } else {
            // Fall back to the second swatch row
            let secondSwatchRow;
            if(origin == "main-product"){
                secondSwatchRow = document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container.options .swatch`)[1];
            } else if(origin == "tile"){
                secondSwatchRow = document.querySelector(`${selector}`) ? document.querySelector(`${selector}`).querySelectorAll('.swatches-container .swatch')[1] : null;
            } else {
                secondSwatchRow = document.querySelector(`${selector}`) ? document.querySelector(`${selector}`).querySelectorAll('.swatches-container .swatch')[1] : null;
            }
            if(secondSwatchRow){
                option_number = 2;
                firstVariantSiblingSwatches = secondSwatchRow.querySelectorAll('.swatch-element');
                checkedInputIndex = origin == "main-product" ? [...firstVariantSiblingSwatches].findIndex(element => element.querySelector('input[type="radio"]:checked')) : [...firstVariantSiblingSwatches].findIndex(element => element.classList.contains('selected'));
                if((checkedInputIndex + 1) < firstVariantSiblingSwatches.length){
                    secondSwatchIndex = checkedInputIndex + 1;
                    secondSwatchValue = firstVariantSiblingSwatches[secondSwatchIndex].getAttribute('data-value');
                }
            }
        }

        secondVariant = product.variants.filter(obj => obj.options[option_number - 1] === secondSwatchValue);
        firstSecondVariant.push(firstVariant);
        firstSecondVariant.push(secondVariant[0]);
    }
    return firstSecondVariant;
}

const returnImageUrls = function(product, firstVariant, secondVariant, origin, widthIndicator, widthIndicatorLower){
    let imageUrlsArray = [];

    // console.log('returnImageUrls', product, firstVariant, secondVariant, origin, widthIndicator, widthIndicatorLower)

    if(origin == "bundle-builder-sub-images" || origin == "bundle-builder-overlay-images"){        
        let variant_data = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML);
        let firstVariantString = origin == "bundle-builder-sub-images" ? variant_data[`${firstVariant.id}`]['image_url'] : variant_data[`${firstVariant.id}`]['bundle_builder_image']['default'];
        imageUrlsArray.push(`${firstVariantString}${widthIndicator}`)
        imageUrlsArray.push(`${firstVariantString}${widthIndicatorLower}`)
        if(secondVariant){
            let secondVariantString = origin == "bundle-builder-sub-images" ? variant_data[`${secondVariant.id}`]['image_url'] : variant_data[`${secondVariant.id}`]['bundle_builder_image']['default'];
            imageUrlsArray.push(`${secondVariantString}${widthIndicator}`);
            imageUrlsArray.push(`${secondVariantString}${widthIndicatorLower}`)
        }
    } else {
        let firstVariantImagesSelectionString = origin == "main-product" ? firstVariant.featured_media.alt : undefined;
        let firstVariantImageUrlsArray = origin == "main-product" ? product.media.filter(obj => obj[`alt`] === firstVariantImagesSelectionString) : [firstVariant.featured_media];
        
        if(firstVariantImageUrlsArray.length > 0){
            firstVariantImageUrlsArray.forEach((url) => {
                if(origin == "main-product"){
                    imageUrlsArray.push(url.src  + widthIndicator)
                    imageUrlsArray.push(url.src  + widthIndicatorLower)
                } else {
                    imageUrlsArray.push(url.src  + widthIndicator)
                    imageUrlsArray.push(url.src  + widthIndicatorLower)
                }
            })
        }
        if(secondVariant && secondVariant.featured_media){
            let secondVariantImagesSelectionString = secondVariant.featured_media.alt;
            let secondVariantImageUrlsArray = origin != "tile" ? product.media.filter(obj => obj[`alt`] === secondVariantImagesSelectionString) : [secondVariant.featured_media];;
            if(secondVariantImageUrlsArray.length > 0){
                secondVariantImageUrlsArray.forEach((url) => {
                    if(origin != "tile"){
                        imageUrlsArray.push(url.src + widthIndicator)
                        imageUrlsArray.push(url.src + widthIndicatorLower)
                    } else {
                        imageUrlsArray.push(url.src  + widthIndicator)
                        imageUrlsArray.push(url.src  + widthIndicatorLower)
                    }
                })
            }
        }
    }

    return imageUrlsArray;
}

function updateArrayWithCompositeImages(productId, tempImageUrls, layerKeys){
    let compositeRenderData = document.querySelector(`.composite-render-image-merchandising-data[data-id="${productId}"]`);
    if(compositeRenderData){
        let compositeData;
        try {
            compositeData = JSON.parse(compositeRenderData.textContent);
        } catch (error) {
            console.error('Error parsing composite render image data:', error);
        }

        let keys = layerKeys || ['first_layer_images', 'second_layer_images'];
        keys.forEach(key => {
            if(compositeData[key]){
                compositeData[key].forEach((image) => {
                    tempImageUrls.push(image.url);
                });
            }
        });
    }
}

window.Branch.product.preloadedImages = {};
window.Branch.product.preloadImages = function(product, type, origin, selector, isQuickView) {
    // console.log('preloadImages', product, type, origin, selector)
    if(product && product.id && window.Branch.product.preloadedImages[`${origin}`] && window.Branch.product.preloadedImages[`${origin}`][product.id]){
        if(origin == "bundle-builder-sub-images" || origin == "bundle-builder-overlay-images"){
        // console.log('Images already preloaded for product', product.id);
            return;
        }
    }

    let imageUrls = [];
    let sizes_string = "100vw";
    let image_selector

    if(origin == "bundle-builder-sub-images"){
        sizes_string = "(max-width:1167px) calc(50vw-275px), calc(((((100vw-84px))*0.55)-14px)/2)";
        image_selector = '.bundle-builder-gallery .bundle-builder-gallery__image.second_img_chair'
    } else if(origin == "bundle-builder-overlay-images"){
        sizes_string = "(max-width:900px) 100vw, (max-width:1167px) calc(100vw-538px), calc(((100vw-84px))*0.55)";
        image_selector = '.bundle-builder-gallery .bundle-builder-gallery__image.chairs'
    } else if(origin == "main-product" || origin == "product"){
        sizes_string = "(max-width:600px) 100vw, (max-width:900px) calc(100vw-48px), (max-width:1167px) calc(((100vw-48px))-490px), (max-width:1259px) calc(((100vw-84px))*0.55), 648px"
        image_selector = '.main-product .main-product__main-product-image'
        // if(isQuickView){
        //     sizes_string = "(max-width:600px) 100vw, (max-width:900px) calc(100vw-48px), (max-width:1167px) calc(((100vw-48px))-490px), (max-width:1259px) calc(((100vw-84px))*0.55), 648px"
        // }
    } else if(origin == 'toggle-header') {
        sizes_string = "(max-width: 599px) calc(((100vw - 52px) - (0.66666 * 24px)) / 1.66666), (max-width: 899px) calc(((100vw - 52px) - (1.66666 * 24px)) / 2.66666), (max-width: 1023px) calc((((100vw - 160px) * 0.6) - (0.3333 * 24px)) / 1.3333), (max-width: 1199px) calc((((100vw - 220px) * 0.6) - (1.3333 * 24px)) / 2.3333), (max-width: 1439px) calc((((100vw - 280px) * 0.7) - (2 * 24px)) / 3), calc(((1160px * 0.7) - (2 * 24px)) / 3)"
        image_selector = '.toggle-header-products-list__carousel-inner .product-tile .product-image-container img:not(.pre-loaded)'
    } else {
        sizes_string = "(max-width:600px) calc(100vw-48px), (max-width:840px) calc(((100vw-148px))/2), (max-width:900px) calc(((77.77vw-20px))/2), (max-width:1440px) calc(((77.77vw-40px))/3), calc(((1120px-40px))/3)"
        image_selector = '.product-tile .product-image-hover__image'
    }

    let imageElement = document.querySelector(`${image_selector}`);
    if (!imageElement && origin == "bundle-builder-overlay-images") {
        // Fall back to sub-images element to calculate width indicators
        imageElement = document.querySelector('.bundle-builder-gallery .bundle-builder-gallery__image.second_img_chair');
    }
    if (!imageElement) {
        console.warn(`Image element not found for selector: ${image_selector}`);
        return imageUrls;
    }

    let currentSrcSet = imageElement.getAttribute('srcset') || imageElement.getAttribute('data-lazy-srcset');
    if (!currentSrcSet) {
        console.warn('No srcset found on image element');
        return imageUrls;
    }

    const srcSetMatches = currentSrcSet.match(/\d+w/g);
    if (!srcSetMatches) {
        console.warn('No width indicators found in srcset');
        return imageUrls;
    }

    const srcSetWidthsArray = srcSetMatches.map(s => parseInt(s));
    const viewportWidth = window.innerWidth;
    const devicePixelRatio = window.devicePixelRatio;

    const widthIndicatorArray = selectSrcset(srcSetWidthsArray, sizes_string, viewportWidth, devicePixelRatio);
    const widthIndicator = widthIndicatorArray[0];
    const widthIndicatorLower = widthIndicatorArray[1]


    if(type == "click" && origin == "main-product"){
        let tempImageUrls = product.media.filter(obj => obj.media_type === 'image').map(obj => obj.src);

        // console.log('tempImageUrls', tempImageUrls)

        updateArrayWithCompositeImages(product.id, tempImageUrls)

        tempImageUrls.forEach((url) => {
            imageUrls.push(`${url}${widthIndicator}`);
            imageUrls.push(`${url}${widthIndicatorLower}`);
        })
    } else if(type == "click" && origin == "tile"){
        if(product.variants.length > 0){
            let variants_featured_media = product.variants.map(variant => variant.featured_media);
            let tempImageUrls = [...new Set(variants_featured_media.map(obj => obj.src))];

            updateArrayWithCompositeImages(product.id, tempImageUrls);

            tempImageUrls.forEach((url) => {
                imageUrls.push(`${url}${widthIndicator}`);
                imageUrls.push(`${url}${widthIndicatorLower}`);
            })
        }
    } else if(type == "click" && origin == "bundle-builder-overlay-images"){
        let variant_data = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML);
        let compositeImageIds = []
        for (const [key, value] of Object.entries(variant_data)) {
            let productId = value.product_id;
            imageUrls.push(value['bundle_builder_image']['default'] + widthIndicator);
            imageUrls.push(value['bundle_builder_image']['default'] + widthIndicatorLower);     
            if(value['bundle_builder_image']['special-conditions'] && value['bundle_builder_image']['special-conditions'].length > 0){
                value['bundle_builder_image']['special-conditions'].forEach((specialCondition) => {
                    imageUrls.push(specialCondition['default-image-url'] + widthIndicator);
                    imageUrls.push(specialCondition['default-image-url'] + widthIndicatorLower);
                    if(specialCondition['option-matches'] && specialCondition['option-matches'].length > 0){
                        specialCondition['option-matches'].forEach((optionMatch) => {
                            imageUrls.push(optionMatch['image-url'] + widthIndicator);
                            imageUrls.push(optionMatch['image-url'] + widthIndicatorLower);
                        })
                    }
                })
            }
            // Load bundle builder composite layers for overlay context
            let compositeOverlayImages = [];
            let compositeImagesThumbnails = [];
            if(!compositeImageIds.includes(productId)){
                updateArrayWithCompositeImages(productId, compositeOverlayImages, ['first_layer_bundle_builder_images', 'second_layer_bundle_builder_images']);
                if(compositeOverlayImages.length > 0){
                    compositeImageIds.push(productId)
                    compositeOverlayImages.forEach((url) => {
                        imageUrls.push(`${url}${widthIndicator}`);
                        imageUrls.push(`${url}${widthIndicatorLower}`);
                    })
                }

                 // Also load regular composite layers at thumbnail size for carousel thumbnails
                updateArrayWithCompositeImages(productId, compositeImagesThumbnails, ['first_layer_images', 'second_layer_images']);
                compositeImagesThumbnails.forEach((url) => {
                    imageUrls.push(`${url}&width=180`);
                    imageUrls.push(`${url}&width=360`);
                })
            }
            
           
            }
    } else if(type == "click" && origin == "bundle-builder-sub-images"){
        if(product.variants.length > 0){
            const updateArrayWithBundleData = (product_variants, bundle_data, arr) => arr.push(...Object.values(product_variants).map(variant => bundle_data[variant.id]));
            let relevantBundleData = [];
            let variant_data = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML);
            updateArrayWithBundleData(product.variants, variant_data, relevantBundleData);
            relevantBundleData.forEach((data_line) => {
                imageUrls.push(data_line['image_url'] + widthIndicator);
                imageUrls.push(data_line['image_url'] + widthIndicatorLower)
            })
            // Load bundle builder composite layers for sub-images context
            let compositeSubImages = [];
            updateArrayWithCompositeImages(product.id, compositeSubImages, ['first_layer_bundle_builder_images', 'second_layer_bundle_builder_images']);
            compositeSubImages.forEach((url) => {
                imageUrls.push(`${url}${widthIndicator}`);
                imageUrls.push(`${url}${widthIndicatorLower}`);
            })
        }
  } else if (origin == 'toggle-header') {
        let toggle_header_image_urls = [];
        let indicatorArray = [];
        document.querySelectorAll('.toggle-header-products-list__carousel-inner .product-tile .product-image-container img:not(.pre-loaded)').forEach(img => { if (!toggle_header_image_urls.includes(img.src)) toggle_header_image_urls.push(img.src); });

        indicatorArray.push(widthIndicator);
        indicatorArray.push(widthIndicatorLower);
        indicatorArray.forEach((indicator) => {
            toggle_header_image_urls.forEach((toggle_header_image_url) => {
                imageUrls.push(`${toggle_header_image_url}${indicator}`)
            })
        })
            
    } else {
            if(product.variants && product.variants.length > 1){
                let firstSecondVariant = window.Branch.product.returnFirstSecondVariant(product, origin, selector);
                let firstVariant = firstSecondVariant[0];
                let secondVariant = firstSecondVariant[1];

                if(firstVariant && secondVariant){
                    imageUrls = returnImageUrls(product, firstVariant, secondVariant, origin, widthIndicator, widthIndicatorLower);
                }

                let isBundleBuilder = origin == 'bundle-builder-sub-images' || origin == 'bundle-builder-overlay-images';
                let compositeLayerKeys = isBundleBuilder ? ['first_layer_bundle_builder_images', 'second_layer_bundle_builder_images'] : undefined;

                if(firstVariant){
                    let variant1CompositeImages = window.Branch.compositeRenderImage.returnRelevantCompositeImagesForVariant(firstVariant, product.id, compositeLayerKeys);
                    // console.log('variant1CompositeImages', variant1CompositeImages)
                    variant1CompositeImages.forEach(img => { if(img.url){ imageUrls.push(img.url + widthIndicator); imageUrls.push(img.url + widthIndicatorLower); }});
                }

                if(secondVariant){
                    let variant2CompositeImages = window.Branch.compositeRenderImage.returnRelevantCompositeImagesForVariant(secondVariant, product.id, compositeLayerKeys);
                    // console.log('secondVariant', secondVariant, 'variant2CompositeImages', variant2CompositeImages)
                    variant2CompositeImages.forEach(img => { if(img.url){ imageUrls.push(img.url + widthIndicator); imageUrls.push(img.url + widthIndicatorLower); }});
                }

                // For bundle builder init, also load regular composite layers at thumbnail size
                if(isBundleBuilder && firstVariant){
                    let variant1ThumbnailComposites = window.Branch.compositeRenderImage.returnRelevantCompositeImagesForVariant(firstVariant, product.id, ['first_layer_images', 'second_layer_images']);
                    variant1ThumbnailComposites.forEach(img => { if(img.url){ 
                        imageUrls.push(img.url + '&width=180'); 
                        imageUrls.push(img.url + '&width=360'); 
                    }});
                }
                if(isBundleBuilder && secondVariant){
                    let variant2ThumbnailComposites = window.Branch.compositeRenderImage.returnRelevantCompositeImagesForVariant(secondVariant, product.id, ['first_layer_images', 'second_layer_images']);
                    variant2ThumbnailComposites.forEach(img => { if(img.url){ 
                        imageUrls.push(img.url + '&width=180'); 
                        imageUrls.push(img.url + '&width=360'); 
                    }});
                }

            } 
        }


    imageUrls = imageUrls.map(url => window.Branch.product.normalizeImageUrl(url));
    imageUrls = [...new Set(imageUrls)];

    var loadedCount = 0;
    var totalImages = imageUrls.length;
    function checkAllImagesLoaded() {
        loadedCount++;
        if (loadedCount === totalImages) {
            // console.log(`All ${totalImages} images have been successfully loaded in the background`);
            if(type == "click" && product && product.id && window.Branch.product.preloadedImages[`${origin}`]){
                window.Branch.product.preloadedImages[`${origin}`][product.id] = true;
            }
            if(origin == 'toggle-header'){
                if(document.querySelector('.toggle-header__outer')){
                    document.querySelector('.toggle-header__outer').setAttribute('data-all-product-images-loaded', true)
                }
            }
        }
      }
    // if(type == "click" && origin == "bundle-builder-overlay-images") {
    //     console.log('imageUrls', imageUrls)
    // }

    imageUrls.forEach(function(url) {

        if(url.includes('&') && !url.includes('?')){
            url = url.replace('&', '?');
        }

        var img = new Image();
        img.onload = checkAllImagesLoaded;
        img.onerror = checkAllImagesLoaded; // Handle errors loading images
        img.src = url;
      });
  }

  const selectSrcset = (srcsetArray, sizes, viewportWidth, devicePixelRatio) => {
    const srcsetCandidates = srcsetArray.map((item, index) => {
      const width= item;
      return { width: parseInt(width), index: index };
    });
  
    const evaluateCalc = (calcStr) => {
      const expression = calcStr.replace(/calc\(([^)]+)\)/g, (_, expr) => expr.replace(/(\d+(\.\d+)?)vw/g, (match, num) => `((${num} / 100) * ${viewportWidth})`)).replaceAll('px', '');
      return Function(`"use strict";return (${expression})`)();
    };
  
    const intendedSize = sizes.split(',').reverse().reduce((acc, size) => {
      let [condition, value] = size.trim().split(/\s+/);
      if(!value){
        value = condition
        condition = undefined
      }
      let maxWidthMatch = undefined;
      if(condition){
        maxWidthMatch = condition.match(/\((max-width:\s*(\d+)px)\)/);
      }
      if (!maxWidthMatch || maxWidthMatch && viewportWidth <= parseInt(maxWidthMatch[2])) {
        let vwValue = value.includes('vw') ? viewportWidth * (parseInt(value) / 100) : value;
        return value.includes('calc') ? evaluateCalc(value) : parseInt(vwValue);
      }
      return acc;
    }, viewportWidth);
  
    const requiredWidth = intendedSize * devicePixelRatio;
    const returnBestCandidate = (srcsetCandidates, requiredWidth) => srcsetCandidates.find(candidate => candidate.width > requiredWidth);

    let bestCandidatesArray = []

    let bestCandidate = returnBestCandidate(srcsetCandidates, requiredWidth);
    let bestCandidateString = bestCandidate ? `&width=${bestCandidate.width}` : `&width=${srcsetCandidates[srcsetCandidates.length - 1].width}`;
    let secondBestCandidateString = bestCandidate && srcsetCandidates[bestCandidate.index - 1] ? `&width=${srcsetCandidates[bestCandidate.index - 1].width}` : `&width=${srcsetCandidates[srcsetCandidates.length - 2].width}`;

    bestCandidatesArray.push(bestCandidateString)
    bestCandidatesArray.push(secondBestCandidateString)

    return bestCandidatesArray;
  };

window.Branch.product._preloadImagesFired = window.Branch.product._preloadImagesFired || {};
window.Branch.product._products = window.Branch.product._products || {};
window.Branch.product._tileDelegationSelectors = window.Branch.product._tileDelegationSelectors || {};

window.Branch.product.initSwatchClickListener = function(product, isQuickView, type, selector){
    if(product.id){
        // Store the product reference per product ID so gallery slideChange can also trigger preloadImages
        if(type !== 'tile'){
            window.Branch.product._products[product.id] = product;
        }

        let swatchContainers = isQuickView ? document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container[data-clicked="false"]`) : document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container[data-clicked="false"], #sticky-atc`);
        if(type == 'tile'){
            swatchContainers = document.querySelectorAll(`${selector}`);
        }

        function clickHandler(event) {
        // Check if the click was on an actual swatch element (input or label within .swatch-element)
        let swatchElement = event.target.closest('.swatch-element');

        if (!swatchElement) return;

        // Only process if the click was on the input or label inside the swatch-element
        let isSwatchClick = event.target.matches('.swatch-element input, .swatch-element label') || event.target.closest('.swatch-element label');
        if (!isSwatchClick) return;

        // Execute the callback function
        // Tiles only preload variant featured images, so they don't need product.media
        let hasImagesToPreload = type == 'tile' ? product.variants.some(v => v.featured_media && v.featured_media.src) : product.media.length > 0;
        if(hasImagesToPreload && !window.Branch.product._preloadImagesFired[product.id]){
            window.Branch.product._preloadImagesFired[product.id] = true;
            let containerSelector = `.main-product .main-product__item#main-product-item-${product.id}`;
            window.Branch.product.preloadImages(product, 'click', type, containerSelector, isQuickView);
        }
        // Remove the click event listener after it's clicked once (not needed for tiles using delegation)
        if(type !== 'tile'){
            swatchContainers.forEach((swatchContainer) => {
                swatchContainer.removeEventListener('click', clickHandler);
            })
        }
      }

      if(type == 'tile'){
        // Use event delegation for tiles since their DOM elements get replaced via JS
        if(!window.Branch.product._tileDelegationSelectors[selector]){
          window.Branch.product._tileDelegationSelectors[selector] = true;
          document.addEventListener('click', function tileClickHandler(event) {
              if(!event.target.closest(selector)) return;
              if(!event.isTrusted) return;
              clickHandler(event);
              if(window.Branch.product._preloadImagesFired[product.id]){
                  document.removeEventListener('click', tileClickHandler);
                  delete window.Branch.product._tileDelegationSelectors[selector];
              }
          });
        }
      } else {
        swatchContainers.forEach((swatchContainer) => {
            swatchContainer.addEventListener('click', clickHandler);
        })
      }
    }
}

window.Branch.product.returnMatchCriteriaObject = function(variantMatchData, selectProductOptions, addOnProduct){
    let matchCriteriaObject = {};
    variantMatchData.forEach((variantMatch) => {
        let index = addOnProduct['options'].findIndex(item => item.toLowerCase() === variantMatch['add-on-option-name'].toLowerCase());
        if(index > -1){
            let nameMatch = variantMatch['option-name'].toLowerCase();
            if(variantMatch['non-identical-values-to-match'] && variantMatch['non-identical-values-to-match'].length > 0){
                variantMatch['non-identical-values-to-match'].forEach((nonIdenticalValueToMatch) => {
                    if(variantMatch['option-name'].toLowerCase() == nonIdenticalValueToMatch['value'].toLowerCase()){
                        nameMatch = nonIdenticalValueToMatch['add-on-value'].toLowerCase()
                    }
                }) 
            }
            let value = selectProductOptions[Object.keys(selectProductOptions).find(key => key.toLowerCase() === nameMatch)];

            if(variantMatch['non-identical-values-to-match'] && variantMatch['non-identical-values-to-match'].length > 0){
                let nonIdenticalValueToMatch = variantMatch['non-identical-values-to-match'].find((match) => match['value'] == value);
                if(nonIdenticalValueToMatch){
                    value = nonIdenticalValueToMatch['add-on-value']
                }
            }
            
            if(!matchCriteriaObject[`${index}`]){
                matchCriteriaObject[`${index}`] = [];
            }
            matchCriteriaObject[`${index}`].push(value);
        }
    })
    return matchCriteriaObject
}

window.Branch.product.returnMatchingVariantAddOn = function(selectedProduct, addOnHandle, addOnProduct, origin){
    let matchingVariantAddOn = addOnProduct['variants'][0];
    let selectedProductId = selectedProduct['product_id'];
    let bundleVariantMatchesData;

    // Check if global bundle_variant_matches_data is usable (not undefined, null, empty array, or empty object)
    let isGlobalDataUsable = typeof bundle_variant_matches_data !== 'undefined' &&
                             bundle_variant_matches_data !== null &&
                             !(Array.isArray(bundle_variant_matches_data) && bundle_variant_matches_data.length === 0) &&
                             !(typeof bundle_variant_matches_data === 'object' && Object.keys(bundle_variant_matches_data).length === 0);

    if (!isGlobalDataUsable) {
        if (origin == 'side-cart') {
            bundleVariantMatchesData = selectedProduct.addon_matches;
        } else if(origin == 'main-product'){
            bundleVariantMatchesData = document.querySelector('#bundle-variant-matches').innerHTML ? JSON.parse(document.querySelector('#bundle-variant-matches').innerHTML) : [];
        } else {
            // For bundle-builder and other contexts, check if selectedProduct has addon_matches (variant-level data)
            bundleVariantMatchesData = selectedProduct.addon_matches || [];
        }
    } else {
        bundleVariantMatchesData = bundle_variant_matches_data;
    }

    let variantMatchData;
    if(bundleVariantMatchesData){
        if(origin == 'main-product' || origin == 'side-cart' || !origin){
            // For main-product, side-cart, and bundle-builder (no origin), bundleVariantMatchesData is an array
            variantMatchData = bundleVariantMatchesData.length > 0 && bundleVariantMatchesData.find(item => item['add-on-handle'] === addOnHandle) ? bundleVariantMatchesData.find(item => item['add-on-handle'] === addOnHandle)['variant-matches'] : null;
        } else {
            // Legacy: for other origins, bundleVariantMatchesData might be keyed by product ID
            variantMatchData = bundleVariantMatchesData[selectedProductId] && bundleVariantMatchesData[selectedProductId].find(item => item['add-on-handle'] === addOnHandle) ? bundleVariantMatchesData[selectedProductId].find(item => item['add-on-handle'] === addOnHandle)['variant-matches'] : null;
        }
    }

    if(variantMatchData){
        let selectProductOptions = origin == 'side-cart' ? selectedProduct['options'] : JSON.parse(selectedProduct['options'].replace(/'/g, '"'));

        let matchCriteriaObject = window.Branch.product.returnMatchCriteriaObject(variantMatchData, selectProductOptions, addOnProduct);

        let matchingVariant = addOnProduct['variants'].find(variant =>
            Object.entries(matchCriteriaObject).every(([index, values]) =>
                values.includes(variant.options[index])
            )
        );

        if(matchingVariant){
            matchingVariantAddOn = matchingVariant;
        }
    }

    return matchingVariantAddOn;
}

window.Branch.product.selectCorrectAddon = function(container, isAddOnsTab, productsArray, origin){
    let addOnId = parseInt(container.querySelector('.main-product .add-to-cart-form').getAttribute('data-product-id'));
    let addOnHandle = container.querySelector('.main-product .add-to-cart-form .select-variant').getAttribute('data-handle');
    let addOnProduct = origin == 'main-product' || origin == 'side-cart' ? productsArray[`${addOnId}`] : productsArray.find(product => product.id === addOnId);

    let productInputs = document.querySelectorAll(`.main-product__item .add-to-cart-form[data-product-id="${addOnId}"] .swatches-container .swatch-element input[type=radio]`);
    let selectInput = document.querySelector(`.main-product__item .add-to-cart-form[data-product-id="${addOnId}"] input#product-${addOnId}-variant`);
    let productSelector = `.main-product__item .add-to-cart-form[data-product-id="${addOnId}"] .swatches-container`;

   if(isAddOnsTab == true){
    let selectedChairDeskProducts = [selectVariantsArray[0][0], selectVariantsArray[1][0]];



    let matchFound = false;
    selectedChairDeskProducts.forEach((selectedProduct) => {
        if(matchFound == false){
            let selectedProductAddons = product_data[`${selectedProduct[`product_id`]}`]['addon_handles'].split(',');

            if (selectedProductAddons.some(e => e.trim() == addOnHandle)) {
                matchFound = true;
                let newProductAddOn = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, addOnHandle, addOnProduct);
                window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'bundle-builder-pop-up', addOnProduct, bundlePricingDataArray);

                /* Check if variant is a bundle product, and if so update the 'bundle-products' input */

                if(variant_data[newProductAddOn.id][`constituents`] && JSON.parse(variant_data[newProductAddOn.id][`constituents`].replace(/'/g, '"')).length > 0){
                    window.Branch.product.updateOldStyleBundle(newProductAddOn.id, addOnId , "bundle-builder")
                }          
              }
        }
    })
   } else if(origin == "main-product"){
    let selectedProduct = {};
    let options_string = '';
 
    if(selected_main_product.selected_variant.option1){
        options_string = `'${selected_main_product.options[0]}': '${selected_main_product.selected_variant.option1}'`;
    }
    if(selected_main_product.selected_variant.option2){
        options_string = `${options_string}, '${selected_main_product.options[1]}': '${selected_main_product.selected_variant.option2}'`;
    }
    if(selected_main_product.selected_variant.option3){
        options_string = `${options_string}, '${selected_main_product.options[2]}': '${selected_main_product.selected_variant.option3}'`;
    }
    options_string = `{ ${options_string} }`;

    selectedProduct['options'] = `${options_string}` 
    selectedProduct['product_id'] = selected_main_product.id;
    selectedProduct['variant_id'] = `${selected_main_product.selected_variant.id}`


    if(addOnProduct){
        let newProductAddOn = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, addOnHandle, addOnProduct, origin);
        window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'main-product-pop-up', addOnProduct, undefined);
    }

   }  else if(origin == "side-cart"){
    let selectedProductId = document.querySelector(`#side-cart .cart-addons .item`).getAttribute('data-main-product-variant')
    let selectedProduct = JSON.parse(document.querySelector(`#variant_data-side-cart`).innerText)[`${selectedProductId}`];
    let newProductAddOn = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, addOnHandle, addOnProduct, origin);
    
    // console.log('selectedProduct', selectedProduct)

    window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'main-product-pop-up', addOnProduct, undefined, 'side-cart');
   }
   else {
    let newProductAddOn = addOnProduct['variants'][0];
    window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'bundle-builder-pop-up', addOnProduct, bundlePricingDataArray);

    /* Check if variant is a bundle product, and if so update the 'bundle-products' input */

    if(variant_data[newProductAddOn.id][`constituents`] && JSON.parse(variant_data[newProductAddOn.id][`constituents`].replace(/'/g, '"')).length > 0){
        window.Branch.product.updateOldStyleBundle(newProductAddOn.id, addOnId , "bundle-builder")
    }  
   }
   if(selectInput.closest('.add-to-cart-form').querySelector('.product-buttons__container') && selectInput.closest('.add-to-cart-form').querySelector('.product-buttons__container').getAttribute('data-initialized') == 'false'){
        selectInput.closest('.add-to-cart-form').querySelector('.product-buttons__container').setAttribute('data-initialized', true);
    }
};

window.Branch.product.updateAddonTile = function(addonsContainerItem, matchingVariant, type){
    addonsContainerItem.setAttribute('data-display-variant', `${matchingVariant.id}`);
    let variantPricingSelector = type && type == 'side-cart' ? '.cart-items' : ''

    /* Update addon tile image */
    let image = addonsContainerItem.querySelector(`.addon-img img:not(.addons_lifestyle-image)`);
    let addonProductId = parseInt(addonsContainerItem.querySelector(`input.checkbox-custom`).getAttribute('data-addon-id'))
 
    image.setAttribute('src', matchingVariant.featured_image.src)
    image.setAttribute('data-src', matchingVariant.featured_image.src)

    image.setAttribute('srcset', window.Branch.functions.returnSrcSet(matchingVariant.featured_image.src))

    /* Update addon tile price */
    let variantPricing;
    if(type == 'side-cart'){
        variantPricing = JSON.parse(document.querySelector(`#full-side-cart-addons-pricing-data`).innerText)[`${addonProductId}`];

    } else {
        variantPricing = JSON.parse(document.querySelector(`#full-pdp-addons-pricing-data`).innerText)[`${addonProductId}`];
    }
    
    let variantPrice = variantPricing[`${matchingVariant.id}`];
    
    let currentPriceRatio = variantPrice.cpx * parseInt(addonsContainerItem.getAttribute('data-quantity-ratio'))
    let originalPriceRatio = variantPrice.opx * parseInt(addonsContainerItem.getAttribute('data-quantity-ratio'))

    if(variantPrice.bdx && variantPrice.bdx > 0){
        currentPriceRatio = currentPriceRatio * ((100 - variantPrice.bdx)/100);
        if(originalPriceRatio == 0){
            originalPriceRatio = variantPrice.cpx;
        }
    }

    // console.log('addonsContainerItem', addonsContainerItem);

    const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(currentPriceRatio, originalPriceRatio, 0, '', addonsContainerItem.getAttribute('data-product-handle'));
    currentPriceRatio = codeDiscountData.currentPrice;
    originalPriceRatio = codeDiscountData.originalPrice;

    let priceString = `+${Shopify.formatMoney(currentPriceRatio, Simplistic.formatMoney).split('.')[0].replace(' ','')}`
    let originalPriceString = `${Shopify.formatMoney(originalPriceRatio, Simplistic.formatMoney).split('.')[0].replace(' ','')}`

    if(addonsContainerItem.getAttribute('data-modification-price-replacement-text')){
        priceString = addonsContainerItem.getAttribute('data-modification-price-replacement-text')
    }

    if(addonsContainerItem.getAttribute('data-modification-compare-at-price-replacement-text')){
        originalPriceString = addonsContainerItem.getAttribute('data-modification-compare-at-price-replacement-text')
    }

    if(addonsContainerItem.getAttribute('data-modification-price-replacement-text') && !addonsContainerItem.getAttribute('data-modification-compare-at-price-replacement-text')){
        originalPriceString = `+${Shopify.formatMoney(currentPriceRatio, Simplistic.formatMoney).split('.')[0].replace(' ','')}`;
    }

    addonsContainerItem.querySelector('span.addon-price').innerHTML = priceString;
    if(addonsContainerItem.querySelector('span[data-price="retail"]')){
        addonsContainerItem.querySelector('span[data-price="retail"]').innerHTML = originalPriceString;
        if(currentPriceRatio < originalPriceRatio){
            addonsContainerItem.querySelector('.price .retail').setAttribute('data-visible', true);
        } else {
            addonsContainerItem.querySelector('.price .retail').setAttribute('data-visible', false);
        }
    }
}

const updateAddonQuantity = function(container, addOnData, origin){
    let addOnId = parseInt(container.querySelector('.main-product .add-to-cart-form').getAttribute('data-product-id'));
    let quantityRatio = 1;
    if(origin == "side-cart" && document.querySelector(`#side-cart .cart-addons input[data-addon-id="${addOnId}"]`)){
        quantityRatio = parseInt(document.querySelector(`#side-cart .cart-addons input[data-addon-id="${addOnId}"]`).closest('.item').getAttribute('data-quantity-ratio'))
     } else if(document.querySelector(`.main-product .addons__container .addons .item input[data-addon-id="${addOnId}"]`)){
        quantityRatio = parseInt(document.querySelector(`.main-product .addons__container .addons .item input[data-addon-id="${addOnId}"]`).closest('.item').getAttribute('data-quantity-ratio'));
     }
    container.querySelector('.main-product__item').setAttribute('data-quantity-ratio', quantityRatio);
    if(quantityRatio > 1){
        let currentTitle = container.querySelectorAll('.main-product__title h1')[0].innerHTML;
        container.querySelectorAll('.main-product__title h1').forEach((mainTitle) => {
            mainTitle.innerHTML = `${currentTitle} (x${quantityRatio})`
        });
    }

    let bundle = false;
    if(addOnData && addOnData[`${addOnId}`] && addOnData[`${addOnId}`].tags && addOnData[`${addOnId}`].tags.length > 0){
        if(addOnData[`${addOnId}`].tags.indexOf("bundle") !== -1)  {
            bundle = true;
        }
    }

    if(origin == "side-cart"){
        let clickSpan = container.querySelector('.addon-add-btn .content-available span');
        if(clickSpan){
            clickSpan.setAttribute('onclick', `addToCartAddOns(${addOnId}, ${bundle}, ${quantityRatio})`)
        }

    } 
}

window.Branch.product.quickViewUpdateOnOpen = function(modal, container, origin, isAddOnsTab){
    container.setAttribute('data-initialized', true);
    let closeButton = container.querySelector('.tingle-modal__close');
    let modalBox = container.querySelector('.tingle-swatch-modal-box');

    if(modalBox){modalBox.appendChild(closeButton)};

    if(origin == 'bundle-builder-form' && products && products.length > 0){
        let atc_button = container.querySelector('#bundle-builder-addon');
        if(atc_button){
        window.Branch.product.selectCorrectAddon(container, isAddOnsTab, products);

        atc_button.addEventListener('click', function(e){
        e.preventDefault();
        let selectElement = container.querySelector('select.select-variant');
        let productId = parseInt(container.querySelector('form.add-to-cart-form').getAttribute('data-product-id'));
        window.Branch.bundle.handleAddOnClick(parseInt(selectElement.value), productId, selectElement.getAttribute('data-handle'));
        modal.close();
        })
        }
    } else if(origin == 'comparison-chart' && document.querySelector('body.template-page-bundles')){
        window.Branch.bundle.updateComparisonChart(container.querySelector('.comparison-chart-section'));
        
    } else if(origin == 'main-product'){
        let productId = parseInt(document.querySelector(`.main-product[data-quick-view="false"] .main-product__item`).getAttribute('id').replaceAll('main-product-item-', ''));
        let addOnData = document.querySelector(`#add_on_product_data--${productId}`) ? JSON.parse(document.querySelector(`#add_on_product_data--${productId}`).innerHTML) : {};
        if(Object.values(addOnData).length > 0){
            updateAddonQuantity(container, addOnData, origin)
            window.Branch.product.selectCorrectAddon(container, isAddOnsTab, addOnData, origin);
        }
    } else if(origin == 'side-cart'){
        let addOnData = document.querySelector(`#add_on_product_data-side-cart`) ? JSON.parse(document.querySelector(`#add_on_product_data-side-cart`).innerHTML) : {};
        // console.log('addOnData', addOnData)
        if(Object.values(addOnData).length > 0){
            updateAddonQuantity(container, addOnData, origin)
            window.Branch.product.selectCorrectAddon(container, isAddOnsTab, addOnData, origin);    
        }
    }
}

const insertGalleryLoadingOverlay = function(selected_variant, product){
    let img_url = selected_variant['featured_image'];
    if(img_url){
        const galleryLoadingOverloadContainer = document.createElement("div");
        galleryLoadingOverloadContainer.classList.add('gallery-loading-overlay-container');
        let galleryLoadingOverloadInnerHTML = `
        <div class="gallery-loading-overlay-container-inner">
            <img
            srcset="${img_url.src}&width=180"
            width="540"
            height="540"
            class="gallery-loading-overlay-container-image"
            alt="${img_url.alt}"                      
            loading="eager"       
        >
        </div>
        `;
        galleryLoadingOverloadContainer.innerHTML = galleryLoadingOverloadInnerHTML;
        let gallery = document.querySelector(`.main-product .main-product-gallery[data-product-id="${product.id}"]`)
        gallery.appendChild(galleryLoadingOverloadContainer);
    }
}

window.Branch.product.selectVariantOnLoad = function(productId, selected_variant, productInputs, selectInput, productSelector, type, product, bundlePricingDataArray, placement){
    if (productInputs.length > 0) {
        productInputs.forEach((productInput) => {
            var $input = productInput;
            var name = productInput.getAttribute('name') + '-' + productId;
            $input.setAttribute('name', name);
        });
    }

    if(type == "bundle-builder-pop-up" || type == 'main-product-pop-up'){
        window.Branch.product.updateDiscountCodePrice(selected_variant, product, type, bundlePricingDataArray, placement);
        insertGalleryLoadingOverlay(selected_variant, product);
    }

    selected_variant.options.forEach(function(option, index) {
        var swatch_selector = '[data-option-index="' + index + '"] .swatch-element[data-value="' + option + '"]';

        if (document.querySelector(productSelector)) {
            var $swatch = document.querySelector(productSelector).querySelector(swatch_selector);
            if ($swatch != null) {
                if(type == 'bundle-builder-form'){
                    $swatch.classList.add('selected');
                }
                else {
                    $swatch.querySelector('input[type="radio"]').checked = true;
                }
            }
        }
    });


    selectInput.setAttribute('value', selected_variant.id);
    selectInput.value = selected_variant.id;

    selectElement = selectInput.parentElement.querySelector('select.select-variant');
    if(selectElement){
        selectElement.value = `${selected_variant.id}`;
    }

    let selectors = selectInput.closest('.add-to-cart-form') ? selectInput.closest('.add-to-cart-form').querySelectorAll(".single-option-selector") : [];

    if(selectors.length > 0){
        if(selected_variant.options[0] && selectors[0]){
            selectors[0].value = selected_variant.options[0];
            const event = new Event('change', {
                'bubbles': true,
                'cancelable': true
            });
            selectors[0].dispatchEvent(event);
        }

        if(selected_variant.options[1] && selectors[1]){
            selectors[1].value = selected_variant.options[1];
            const event = new Event('change', {
                'bubbles': true,
                'cancelable': true
            });
            selectors[1].dispatchEvent(event);
        }

        if(selected_variant.options[2] && selectors[2]){
            selectors[2].value = selected_variant.options[2];
            const event = new Event('change', {
                'bubbles': true,
                'cancelable': true
            });
            selectors[2].dispatchEvent(event);
        }
    }
}

const updateSwatchModalHeight = function(modalBox, swatchData) {
    // If swatchData is not provided, try to get it from global scope or skip
    if(!swatchData && typeof window.currentSwatchElementsData !== 'undefined'){
        swatchData = window.currentSwatchElementsData;
    }

    if(modalBox && swatchData){
        const swatchValueElement = modalBox.querySelector('.swatch-modal__swatch-value');
        const infoContainers = modalBox.querySelectorAll('.swatch-modal__swatch-info-container');

        if(swatchValueElement && infoContainers.length > 0){
            let maxHeight = 0;
            let minHeight = Infinity;
            const originalText = swatchValueElement.textContent;

            // Loop through all swatch data entries to find the maximum and minimum heights
            Object.entries(swatchData).forEach(function(entry, index){
                const formattedValue = entry[1].option_value.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

                // Temporarily set the text to measure height
                swatchValueElement.textContent = formattedValue;
                const height = swatchValueElement.offsetHeight;

                if(height > maxHeight){
                    maxHeight = height;
                }
                if(height < minHeight){
                    minHeight = height;
                }
            });

            // Restore original text
            swatchValueElement.textContent = originalText;

            // Only apply height adjustments if heights are not all the same
            if(maxHeight !== minHeight){
                // Set all info containers to the maximum height
                infoContainers.forEach(function(container){
                    container.style.height = maxHeight + 'px';
                });

                // Set the parent swatch-modal-box height based on window width
                if(window.innerWidth < 576){
                    modalBox.style.height = `calc(100vw - (2 * 24px) - 8px + ${maxHeight}px)`;
                } else {
                    modalBox.style.height = (528 + maxHeight + 'px');
                }
            }
        }
    }
};

const checkSizeSwatchesInline = function() {
    const swatchContainers = document.querySelectorAll('.swatches-container[data-type=main-product] .swatch.size .swatch-tab-inner');

    swatchContainers.forEach(container => {
        const swatchElements = container.querySelectorAll('.swatch-element');

        if (swatchElements.length === 0) {
            container.setAttribute('data-size-swatches-inline', 'false');
            return;
        }

        const originalStyle = container.style.cssText;
        container.style.display = 'flex';
        container.style.flexWrap = 'nowrap';
        container.style.overflow = 'hidden';

        let totalWidth = 0;
        let canDisplayInline = true;

        swatchElements.forEach(element => {
            const elementStyle = window.getComputedStyle(element);
            const elementWidth = element.offsetWidth +
                               parseFloat(elementStyle.marginLeft) +
                               parseFloat(elementStyle.marginRight);
            totalWidth += elementWidth;
        });

        const containerStyle = window.getComputedStyle(container);
        if(swatchElements.length > 1){
            totalWidth = totalWidth + (parseFloat(containerStyle.gap) * (swatchElements.length - 1));
        }

        const containerWidth = container.offsetWidth
            - parseFloat(containerStyle.paddingLeft)
            - parseFloat(containerStyle.paddingRight)
            - parseFloat(containerStyle.borderLeftWidth)
            - parseFloat(containerStyle.borderRightWidth);
        canDisplayInline = totalWidth <= containerWidth;

        container.style.cssText = originalStyle;

        container.setAttribute('data-size-swatches-inline', canDisplayInline.toString());
    });
};

const mainProductReformat = function(){
    openCloseAccordionSlides();
    window.Branch.product.formatSwatches();
    window.Branch.product.resizeSwatchesHeader(`.main-product`);
    window.Branch.product.customSwatchContainerResize(`.main-product`);
    window.Branch.product.formatPreOrderSwatch();
    checkSizeSwatchesInline();
}

const initMainProductSection = function(){
    window.Branch.product.initAccordion();
    let firstAccordionHeader = document.querySelector('.main-product__accordion .main-product__accordion-li[data-index="0"] .main-product__accordion-header-container');

    if (firstAccordionHeader) {
        const onScroll = function() {
            firstAccordionHeader.click();
            window.removeEventListener('scroll', onScroll);
        };
        window.addEventListener('scroll', onScroll);
    }

    const addons = document.querySelector(".main-product .addons__container");
    if(addons){
        window.Branch.addons.initAddonStyling('pdp', parseInt(addons.getAttribute('data-id')), 'repos');
    }
}

window.Branch.product.updateOldStyleBundle = function(variant_id, product_id , origin){
    console.log('updateOldStyleBundle')
    if(origin == "bundle-builder"){
        let constituentsArrayString = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML)[`${variant_id}`]['constituents'];
        let constituentsArray = JSON.parse(constituentsArrayString.replace(/'/g, '"'));
        let bundleInput = document.querySelector(`#main-product-item-${product_id} .add-to-cart-form .bundle-products`);
        if(bundleInput){
            bundleInput.value = JSON.stringify(constituentsArray);
            bundleInput.setAttribute('value', JSON.stringify(constituentsArray));
        }
    }
}

const checkIfIncompatible = function(product, variant, selectedAddon, addOnVariantMatches, addOnProduct, addOnProductHandle, variantMatches){
    let mismatched = true;
    let currentAddOnVariant = Object.values(addOnProduct.variants).find(entry => entry['id'] === selectedAddon['variantId']);
    let productOptions = addOnProduct.options.map(name => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''));
    let productOptionValues = currentAddOnVariant.options;
        
    if(variantMatches && mismatched == true){
        let matchesFullfilled = 0;
        let nonCompulsoryMatchConditions = 0;
        let nonCompulsoryMatchConditionsMet = false;

        variantMatches.forEach((variantMatch) => {
            if(variantMatch['match-not-required-if-other-options-match'] == true) {
                nonCompulsoryMatchConditions = nonCompulsoryMatchConditions + 1;
            }
        });
        variantMatches.forEach((variantMatch) => {
            if(variantMatch['non-compulsory-match'] == true){
                matchesFullfilled = matchesFullfilled + 1
            } else {
                productOptions.forEach((productOption, index) => {
                    if(variantMatch['add-on-option-name'].toLowerCase().replace(' ', '-') == productOption){
                        let value = productOptionValues[index];
                        let optionIndex = product['options'].findIndex(item => item.toLowerCase() === variantMatch['option-name'].toLowerCase());
                        let variantOptionValue = variant.options[optionIndex]
                        let matchValue = variantOptionValue;

                            if(variantMatch['non-identical-values-to-match'] && variantMatch['non-identical-values-to-match'].length > 0){
                                let productOptionValue = productOptionValues[`${index}`].replaceAll('@', ',');
                                variantMatch['non-identical-values-to-match'].forEach((nonIdenticalMatch) => {
                                    if(nonIdenticalMatch['value'] == variantOptionValue && nonIdenticalMatch['add-on-value'] == productOptionValue){
                                        matchValue = nonIdenticalMatch['add-on-value'];
                                        matchesFullfilled = matchesFullfilled + 1;
                                    }
                                })
                            } else if(value === matchValue){
                                if(variantMatch['match-not-required-if-other-options-match'] == true && nonCompulsoryMatchConditionsMet == false){
                                    matchesFullfilled = matchesFullfilled + nonCompulsoryMatchConditions;
                                    nonCompulsoryMatchConditionsMet = true;
                                } else if(!variantMatch['match-not-required-if-other-options-match']) {
                                    matchesFullfilled = matchesFullfilled + 1;
                                }
                            }                 
                    }
                })
            }
        })

        if(matchesFullfilled >= variantMatches.length){
            mismatched = false;
        }
        // console.log('mismatched', mismatched, 'matchesFullfilled', matchesFullfilled, 'variantMatches.length', variantMatches.length)
    }
    return mismatched;
}

window.Branch.product.updateSelectedAddons = function(product, variant){
    let selectedAddons = document.querySelector('#addon-products-for-atc') && document.querySelector('#addon-products-for-atc').getAttribute('value') ? JSON.parse(document.querySelector('#addon-products-for-atc').getAttribute('value')) : [];
    if(selectedAddons.length > 0){
        let matchesData = document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`) && document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML ? JSON.parse(document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML) : [];
        let addOnData = document.querySelector(`#add_on_product_data--${product.id}`) ? JSON.parse(document.querySelector(`#add_on_product_data--${product.id}`).innerHTML) : {};
        let msbdData = document.querySelector(`#variant_ship_date_metafield_values--${product.id}`) ? JSON.parse(document.querySelector(`#variant_ship_date_metafield_values--${product.id}`).innerHTML) : {};
        let selectProductOptions = {};
        if(product.options.length > 0){
            product.options.forEach((option, index) => {
            let value = variant.options[index];
            selectProductOptions[`${option}`] = value; 
            })
        }
        if(matchesData.length > 0 && Object.values(addOnData).length > 0){
            selectedAddons.forEach((selectedAddon, selectedAddonIndex) => {
                let addOnProduct = Object.values(addOnData).find(entry => entry['handle'] === selectedAddon['productHandle']);
                let addonProductMatchData = matchesData.find(entry => entry['add-on-handle'] === selectedAddon['productHandle']) ? matchesData.find(entry => entry['add-on-handle'] === selectedAddon['productHandle'])[`variant-matches`] : [];
                let incompatible = checkIfIncompatible(product, variant, selectedAddon, matchesData, addOnProduct, selectedAddon['productHandle'], addonProductMatchData, addonProductMatchData);
                if(incompatible == true){
                    let matchingVariant = addOnProduct.variants[0]
                    if(addonProductMatchData.length > 0){
          
                      let matchCriteriaObject = window.Branch.product.returnMatchCriteriaObject(addonProductMatchData, selectProductOptions, addOnProduct);
                      matchingVariant = addOnProduct['variants'].find(variant =>
                          Object.entries(matchCriteriaObject).every(([index, values]) =>
                              values.includes(variant.options[index])
                          )
                      );
                      let addonsContainerItem = document.querySelector(`#main-product-item-${product.id} .addons__container .addons .item input[data-addon-id="${addOnProduct.id}"]`).closest('.item');
                      if(matchingVariant && matchingVariant.featured_image && addonsContainerItem){
                            window.Branch.product.updateAddonTile(addonsContainerItem, matchingVariant);
                      }

                      selectedAddons[selectedAddonIndex] = {"productHandle": selectedAddon['productHandle'], "quantity": selectedAddon['quantity'], "variantId": `${matchingVariant.id}`, "shipping": `${msbdData[`${matchingVariant.id}`]}`, "bundle": selectedAddon.bundle, "bundleConstituents": selectedAddon.bundleConstituents, "mainProductQuantity": selectedAddon.mainProductQuantity} 
                      document.querySelectorAll(`.addons-variants .item[data-addon-handle="${selectedAddon['productHandle']}"] .swatch-element input[type="radio"]`).forEach((addonInput) => {
                        addonInput.checked = false;
                      });
                      let newVariantInput = document.querySelector(`.addons-variants .item[data-addon-handle="${selectedAddon['productHandle']}"] .swatch-element input[type="radio"][value="${matchingVariant.id}"]`);
                      if(newVariantInput){newVariantInput.checked = true};
                    }
                }
            });
            document.querySelector('#addon-products-for-atc').setAttribute('value', JSON.stringify(selectedAddons));
            document.querySelector('#addon-products-for-atc').value = JSON.stringify(selectedAddons);


            
        }
    }
    if(document.querySelectorAll('.swatches-container__tab-outer-container .amount-selected').length > 0){
        document.querySelectorAll('.swatches-container__tab-outer-container .amount-selected').forEach((amountSelected) => {
            amountSelected.innerHTML = selectedAddons.length;
        })
        
    }
}

window.Branch.product.updateAddonThumbnailsToMatchSelectedVariant = function(product, variant){
    let addonsContainerItems = document.querySelectorAll(`#main-product-item-${product.id} .addons__container .addons .item`)    
    if(addonsContainerItems.length > 0){
    let matchesData = document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`) && document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML ? JSON.parse(document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML) : [];
    let addOnData = document.querySelector(`#add_on_product_data--${product.id}`) ? JSON.parse(document.querySelector(`#add_on_product_data--${product.id}`).innerHTML) : {};
     
    let selectProductOptions = {};
      if(product.options.length > 0){
        product.options.forEach((option, index) => {
          let value = variant.options[index];
          selectProductOptions[`${option}`] = value; 
        })
      }
      if(matchesData.length > 0 && Object.values(addOnData).length > 0){
        addonsContainerItems.forEach((addonsContainerItem) => {
            let checked = addonsContainerItem.querySelector(`#addon-${addonsContainerItem.querySelector('.checkbox-custom-label').getAttribute('data-addon-id')}`).checked;
            if(checked == false){


            let addOnProductHandle = addonsContainerItem.querySelector(`.checkbox-custom-label`).getAttribute('data-addon-handle');
            let addOnProductId = parseInt(addonsContainerItem.querySelector(`.checkbox-custom-label`).getAttribute('data-addon-id'));

            let addonProductMatchData = matchesData.find(entry => entry['add-on-handle'] === addOnProductHandle);
            let addOnProduct = addOnData[`${addOnProductId}`];
            if(addOnProduct) {
                let matchingVariant = addOnProduct.variants[0]
                if(addonProductMatchData){
                    addonProductMatchData = addonProductMatchData[`variant-matches`];
    
                    let matchCriteriaObject = window.Branch.product.returnMatchCriteriaObject(addonProductMatchData, selectProductOptions, addOnProduct);
                    matchingVariant = addOnProduct['variants'].find(variant =>
                        Object.entries(matchCriteriaObject).every(([index, values]) =>
                            values.includes(variant.options[index])
                        )
                    );
                }
                if(matchingVariant && matchingVariant.featured_image && parseInt(addonsContainerItem.getAttribute('data-display-variant')) != matchingVariant.id){
                    window.Branch.product.updateAddonTile(addonsContainerItem, matchingVariant);
                }
            }
            }
        })
        }
    }
}

const updateOptionsInSelector = function(selectorIndex, item, optionsMap, optionsMapAll) {
    let selectors = item.querySelectorAll(".single-option-selector")
    let selector;
    let key;

    switch (selectorIndex) {
        case 0:
            key = "root";
            selector = selectors[0];
            break;
        case 1:
            key = selectors[0].value;
            selector = selectors[1];
            break;
        case 2:
            key = selectors[0].value;
            key += " / " + selectors[1].value;
            selector = selectors[2];
            break;
    }
    
    let initialValue = selector.value;
    selector.innerHTML = ""; // Clear the existing options
    
    let options = optionsMapAll[key];
    if (options) {
        options.forEach(function(option) {
            let newOption = document.createElement("option");
            newOption.value = option;
            newOption.innerHTML = option;
            selector.appendChild(newOption);
        });
    }
    
    let availableOptions = optionsMap[key];
    let existingOptions = optionsMapAll[key];
    
    if (availableOptions && availableOptions.indexOf(initialValue) !== -1) {
        selector.value = initialValue;
    }
    
        let selected_variant_array = key.split(" / ");
        let swatches = item.querySelectorAll(".swatch");

        if(swatches.length > selected_variant_array.length){
            let finalSwatchValueCurrent = swatches[swatches.length - 1].querySelector('.swatch-element.selected') ? swatches[swatches.length - 1].querySelector('.swatch-element.selected').getAttribute('data-value') : undefined;
            if(finalSwatchValueCurrent && existingOptions && existingOptions.includes(finalSwatchValueCurrent)){
                selected_variant_array.push(finalSwatchValueCurrent);
            } else if(existingOptions) {
                selected_variant_array.push(existingOptions[0]);
            }
        }

        if(selected_variant_array.length == swatches.length){
            item.setAttribute('data-variant-description', `${selected_variant_array}`)
        }

    item.querySelectorAll('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').forEach(function(element) {
        const dataValue = element.getAttribute("data-value");
    
        if (existingOptions && existingOptions.includes(dataValue)) {
            element.removeEventListener('click', handleClick);
            element.removeEventListener('mouseenter', handleClick);
    
            if (availableOptions && availableOptions.includes(dataValue)) {
                element.classList.remove("soldout");
                element.querySelector("input[type='radio']").removeAttribute("checked");
                element.querySelector('.tooltip').textContent = dataValue;
            } else {
                if (!item.closest('.template-product-chat-with-sales')) {
                    element.classList.add("soldout");
                    element.querySelector("input[type='radio']").removeAttribute("checked");
                    element.querySelector('.tooltip').textContent = 'Out of stock';
                }
    
                if (window.Branch.functions.isTouchDevice()) {
                    element.addEventListener('click', handleClick);
                } else {
                    element.addEventListener('mouseenter', handleClick);
                }
            }
    
            element.querySelector('input').disabled = false;
            element.classList.remove("option-not-available");
        } else {
            element.querySelector('input').disabled = true;
            element.querySelector('.tooltip').textContent = 'Not available';
            element.classList.add("option-not-available");
    
            if (window.Branch.functions.isTouchDevice()) {
                element.addEventListener('click', handleClick);
            } else {
                element.addEventListener('mouseenter', handleClick);
            }
        }
    });

    function handleClick() {
            const originalTooltip = this.querySelector('.tooltip');
            const rect = originalTooltip.getBoundingClientRect();

            const floatingTooltip = originalTooltip.cloneNode(true);
            floatingTooltip.classList.add('mobile-display');
            floatingTooltip.classList.add('tooltip--temp');

            floatingTooltip.style.position = 'fixed';
            floatingTooltip.style.top = `${rect.top}px`;
            floatingTooltip.style.left = `${rect.left}px`;
            floatingTooltip.style.width = `${rect.width}px`; 
            floatingTooltip.style.pointerEvents = 'none';
            floatingTooltip.style.zIndex = '9999';
            floatingTooltip.style.opacity = '1';
            floatingTooltip.style.visibility = 'visible';
            floatingTooltip.style.transform = 'translateY(calc(-100% + 5px)';
            floatingTooltip.style.height = 'fit-content';

            document.querySelector('#page').appendChild(floatingTooltip);

            setTimeout(() => {
                floatingTooltip.remove();
            }, 2000);
}
    
    if (availableOptions && availableOptions.indexOf(initialValue) !== -1) {
        selector.value = initialValue;
    }
};

window.Branch.product.linkOptionSelectors = function(product, item) {
    let optionsMap = {};
    let optionsMapAll = {};
    let selectors = item.querySelectorAll(".single-option-selector")

    product.variants.forEach(variant => {
        optionsMapAll.root = optionsMapAll.root || [];
        optionsMapAll.root.push(variant.option1);
        optionsMapAll.root = Shopify.uniq(optionsMapAll.root);

        if (product.options.length > 1) {
            let key = variant.option1;
            optionsMapAll[key] = optionsMapAll[key] || [];
            optionsMapAll[key].push(variant.option2);
            optionsMapAll[key] = Shopify.uniq(optionsMapAll[key]);
        }

        if (product.options.length === 3) {
            let key = variant.option1 + " / " + variant.option2;
            optionsMapAll[key] = optionsMapAll[key] || [];
            optionsMapAll[key].push(variant.option3);
            optionsMapAll[key] = Shopify.uniq(optionsMapAll[key]);
        }

        if (variant.available) {
            optionsMap.root = optionsMap.root || [];
            optionsMap.root.push(variant.option1);
            optionsMap.root = Shopify.uniq(optionsMap.root);

            if (product.options.length > 1) {
                let key = variant.option1;
                optionsMap[key] = optionsMap[key] || [];
                optionsMap[key].push(variant.option2);
                optionsMap[key] = Shopify.uniq(optionsMap[key]);
            }

            if (product.options.length === 3) {
                let key = variant.option1 + " / " + variant.option2;
                optionsMap[key] = optionsMap[key] || [];
                optionsMap[key].push(variant.option3);
                optionsMap[key] = Shopify.uniq(optionsMap[key]);
            }
        }
    });

    updateOptionsInSelector(0, item, optionsMap, optionsMapAll);
    if (product.options.length > 1) updateOptionsInSelector(1, item, optionsMap, optionsMapAll);
    if (product.options.length === 3) updateOptionsInSelector(2, item, optionsMap, optionsMapAll);

    selectors[0].addEventListener('change', function() {
        updateOptionsInSelector(1, item, optionsMap, optionsMapAll);
        if (product.options.length === 3) updateOptionsInSelector(2, item, optionsMap, optionsMapAll);
        return true;
    });

    selectors[1].addEventListener('change', function() {
        if (product.options.length === 3) updateOptionsInSelector(2, item, optionsMap, optionsMapAll);
        return true;
    });
}

 window.Branch.product.updateSwatchRows = function(parentClass) {
    // console.log('updateSwatchRows!', parentClass)
        document.querySelectorAll(`${parentClass} .swatches-container .swatches-container__tab-outer-container`).forEach((outerContainer) => {
            let container = outerContainer.querySelector('.swatch-tab-inner');
            if(container){
                const swatches = container.querySelectorAll('.swatch-element');
                const rows = new Set();
                swatches.forEach(swatch => {
                    rows.add(swatch.offsetTop);
                });

                let rowsCount = rows.size;
                let productId = outerContainer.closest('.swatches-container').getAttribute('data-product-id');

                container.closest('.swatches-container__tab-outer-container').setAttribute('data-rows-size', rowsCount);
                // if(container.closest('.swatches-container[data-total-swatches="1"]')){
                //     container.closest('.swatches-container[data-total-swatches="1"]').setAttribute('data-single-swatch-wrapped', `${rowsCount > 1 ? 'true' : 'false'}`);
                //     if(rowsCount > 1){
                //         window.Branch.product.updateSwatchRowsStyling(parentClass, productId);
                //     } else {
                //         outerContainer.style.removeProperty('height');
                //         container.style.removeProperty('height');
                //     }
                // }
            }
        })
    }

window.Branch.product.applySwatchTabSizing = function(container) {
    let CLOSED_HEIGHT = 52;
    let cutOffRow = 3;

    // Empirical chrome above/below `.swatch-tab-inner` when inner is at natural height.
    const CHROME_NATURAL = 10;

    const swatch = container.querySelector('.swatch');
    const inner = container.querySelector('.swatch-tab-inner');
    if (!swatch || !inner) return;

    // Reset inner so we measure swatch's natural row layout
    inner.style.removeProperty('height');

    // Group .swatch-element children into rows by visual top.
    // .swatch wraps .swatch-tab-inner with ~16px of header above, so we measure
    // relative to the INNER (the scroll container) — the cutoff we set on inner.height
    // lives in inner's coordinate system.
    // Per-row height naturally varies when an element in the row has
    // data-element-in-row-has-label="true" — we measure rendered heights.
    const innerTop = inner.getBoundingClientRect().top;
    const rowMap = new Map();
    swatch.querySelectorAll('.swatch-element').forEach(el => {
        const r = el.getBoundingClientRect();
        const top = Math.round(r.top - innerTop);
        if (!rowMap.has(top)) rowMap.set(top, []);
        rowMap.get(top).push(r.height);
    });
    const rows = Array.from(rowMap.keys())
        .sort((a, b) => a - b)
        .map(top => ({ top, height: Math.max(...rowMap.get(top)) }));

    if (rows.length >= cutOffRow) {
        // 3+ rows: clamp so the user sees through halfway of row 3 (forces scroll).
        // Container height = inner height + CLOSED_HEIGHT so the cutoff row visibly clips.
        const row3 = rows[cutOffRow - 1];
        const cutoff = Math.round(row3.top + row3.height / 2);
        inner.style.height = `${cutoff}px`;
        container.style.height = `${cutoff + CLOSED_HEIGHT}px`;
        container.setAttribute('data-scrollable', 'true');
    } else {
        // 1-2 rows: show all content, no scrollbar.
        // Account for a negative margin-top on .swatch (e.g. custom-color-swatch products
        // pull the swatch up over the close-button row), so the container doesn't end up
        // ~16px taller than the rendered content.
        inner.style.removeProperty('height');
        const swatchMarginTop = parseFloat(getComputedStyle(swatch).marginTop) || 0;
        container.style.height = `${swatch.offsetHeight + swatchMarginTop + CLOSED_HEIGHT + CHROME_NATURAL}px`;
        container.removeAttribute('data-scrollable');
    }

    // iOS Safari hides native scrollbars; mark scrollable inners for a CSS-rendered one
    if (window.Branch.functions.isIOSSafari && window.Branch.functions.isIOSSafari() && isScrollable) {
        container.setAttribute('data-show-fake-scrollbar', 'true');
    } else {
        container.removeAttribute('data-show-fake-scrollbar');
    }

    // Recompute the custom-color-swatch container widths now that the scrollable
    // state has been (re)set — the inner's usable width changes when a scrollbar
    // appears, so the explicit widths setCustomContainerWidth wrote earlier may
    // need to shrink (otherwise the rightmost swatch in a row sits under the
    // scrollbar).
    const colorSwatch = container.querySelector('.swatches-container__color-swatches-container');
    if (colorSwatch) {
        setCustomContainerWidth(colorSwatch);
    }
};

window.Branch.product.updateSwatchRowsStyling = function(parentClass, productId){
        // console.log('updateSwatchRowsStyling', parentClass)
        let swatchesContainerSelector = productId ? `.swatches-container[data-product-id="${productId}"]` : '.swatches-container';
        document.querySelectorAll(`${parentClass} ${swatchesContainerSelector} .swatches-container__tab-outer-container`).forEach((outerContainer) => {
            // if(outerContainer.closest('.swatches-container').getAttribute('data-total-swatches') == 1 && outerContainer.closest('.swatches-container').getAttribute('data-rows-size') == '1'){
            //     return;
            // }
            if (outerContainer.getAttribute('data-status') === 'open') {
                window.Branch.product.applySwatchTabSizing(outerContainer);
            }
        });
    }

window.Branch.product.setUpSwatchTabsEventListener = function(type){
    let parentClass = type == 'main' ? '.main-product' : '.bundle-builder__item';
    let closedHeight = 52;

    if(type == 'main' && document.querySelector('body').classList.contains('template-page-hype-erg')){
        parentClass = '#hype-page-variant-inspect-container .product-tile'
    }

    window.Branch.product.updateSwatchRows(parentClass);
    
    document.addEventListener('click', function (event) {
        let target = event.target.closest(`${parentClass} .swatches-container:not([data-initialized="true"])`);
        let targetContainer = event.target.closest(`${parentClass} .swatches-container .swatches-container__tab-outer-container`);
        let targetButton = event.target.closest(`${parentClass} .swatches-container .swatches-container__tab-outer-container .swatches-container__tab-button`);
        let type = 'swatches'
        if(event.target.closest(`${parentClass} .swatches-container__tab-outer-container[data-type="addons"]`)) {
            target = event.target.closest(`${parentClass} .swatches-container__tab-outer-container[data-type="addons"]`);
            targetContainer = event.target.closest(`${parentClass} .swatches-container__tab-outer-container[data-type="addons"] `);
            targetButton = event.target.closest(`${parentClass} .swatches-container__tab-outer-container[data-type="addons"] .swatches-container__tab-button`);
            type = 'addons'
        }
        if(event.target.closest(`${parentClass} .swatches-container__tab-outer-container[data-type="fake-promo-swatch"]`)) {
            target = event.target.closest(`${parentClass} .swatches-container__tab-outer-container[data-type="fake-promo-swatch"]`);
            targetContainer = event.target.closest(`${parentClass} .swatches-container__tab-outer-container[data-type="fake-promo-swatch"] `);
            targetButton = event.target.closest(`${parentClass} .swatches-container__tab-outer-container[data-type="fake-promo-swatch"] .swatches-container__tab-button`);
            type = 'fake-promo-swatch'
        }

        if (target && targetContainer && targetButton) {
            event.preventDefault();
            if(!event.target.closest('.addons')) {
                let action = targetContainer.getAttribute('data-status') == 'closed' ? 'open' : 'closed';

                if (action === 'open') {
                    // const allOpenContainers = document.querySelectorAll(`${parentClass} .swatches-container:not([data-total-swatches="1"]) .swatches-container__tab-outer-container[data-status="open"], ${parentClass} .swatches-container__tab-outer-container[data-type="addons"][data-status="open"], ${parentClass} .swatches-container__tab-outer-container[data-type="fake-promo-swatch"][data-status="open"]`);
                    const allOpenContainers = document.querySelectorAll(`${parentClass} .swatches-container .swatches-container__tab-outer-container[data-status="open"], ${parentClass} .swatches-container__tab-outer-container[data-type="addons"][data-status="open"], ${parentClass} .swatches-container__tab-outer-container[data-type="fake-promo-swatch"][data-status="open"]`);

                    allOpenContainers.forEach(openContainer => {
                        if (openContainer !== targetContainer) {
                            openContainer.setAttribute('data-status', 'closed');
                            openContainer.style.height = `${closedHeight}px`;
                            if (openContainer.querySelector('.swatch-tab-inner')) {
                                openContainer.querySelector('.swatch-tab-inner').style.removeProperty('height');
                            }
                        }
                    });

                    // Remove data-show-fake-scrollbar from all tab containers when opening a new tab
                    const allTabContainers = document.querySelectorAll(`${parentClass} .swatches-container__tab-outer-container`);
                    allTabContainers.forEach(container => {
                        container.removeAttribute('data-show-fake-scrollbar');
                    });
                }
            setTimeout(function() {
                if(action == 'closed') {
                    targetContainer.setAttribute('data-status', action);
                    targetContainer.style.height = `${closedHeight}px`;
                    if(targetContainer.querySelector('.swatch-tab-inner')){
                        targetContainer.querySelector('.swatch-tab-inner').style.removeProperty('height');
                    }
                    return;
                }

                targetContainer.setAttribute('data-status', action);

                if (type == 'swatches' && targetContainer.querySelector('.swatch') && targetContainer.querySelector('.swatch-tab-inner')) {
                    // Helper sets both inner.height and container.height in one shot
                    window.Branch.product.applySwatchTabSizing(targetContainer);
                } else if (type == 'addons') {
                    let contentsHeight = closedHeight + targetContainer.querySelector('.addons__container ').offsetHeight;
                    if(targetContainer.querySelector('.addons__container').getAttribute('data-carousel-quantity') == '1'){
                        contentsHeight = contentsHeight + 30;
                    }
                    targetContainer.style.height = `${contentsHeight}px`;
                } else {
                    // fake-promo-swatch
                    const contentsHeight = closedHeight + targetContainer.querySelector('.pdp-fake-promo-swatch ').offsetHeight + 20;
                    targetContainer.style.height = `${contentsHeight}px`;
                }

                // iOS Safari fake-scrollbar marker — for swatches it's handled inside applySwatchTabSizing
                if (type != 'swatches' && window.Branch.functions.isIOSSafari && window.Branch.functions.isIOSSafari()) {
                    const swatchTabInner = targetContainer.querySelector('.swatch-tab-inner');
                    if (swatchTabInner && swatchTabInner.scrollHeight > swatchTabInner.clientHeight) {
                        targetContainer.setAttribute('data-show-fake-scrollbar', 'true');
                    }
                }
            }, 1)
            }
        }
    });

    

   let resizeTimeout;
    let classType = !document.querySelector('body.template-page-bundles') && !document.querySelector('body.template-product-bundle') ? '.main-product' : '.bundle-builder__item';
    window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
            window.Branch.product.updateSwatchRows(classType);
            window.Branch.product.updateSwatchRowsStyling(classType);
        }, 250);
    });

    let firstButton = document.querySelector(`${parentClass} .swatches-container .swatches-container__tab-button[data-clickable="true"]`);
    if(classType == ".bundle-builder__item"){
        firstButton = document.querySelector(`${parentClass} .bundle-builder-form__selected-product-variants-container .swatches-container .swatches-container__tab-button[data-clickable="true"]`);
    }

    
    if (firstButton) {
        const event = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        firstButton.dispatchEvent(event);
    }

     window.Branch.product.removeOverlayFromSwatches = function(productId, parentClass) {
        let mainProductSwatches = document.querySelectorAll(`${parentClass} .swatch`);
        let totalWithParent = 0;
        mainProductSwatches.forEach((swatch) => {
            if(swatch.closest(`body .swatches-container[data-product-id="${productId}"]`)){
                totalWithParent++;
            }
        });

        let processedWithParent = 0;
        mainProductSwatches.forEach((mainProductSwatch, index) => {
            let parent = mainProductSwatch.closest(`body .swatches-container[data-product-id="${productId}"]`)
            if(parent){
                processedWithParent++;
                if(parent.getAttribute('data-click-allowed') != 'true' && parent.getAttribute('data-click-allowed-transition') != 'true' && processedWithParent === totalWithParent){
                    parent.setAttribute('data-click-allowed-transition', true);

                    setTimeout(() => {
                        parent.setAttribute('data-click-allowed', true);
                        parent.removeAttribute('data-click-allowed-transition');
                    }, 500);
                }
            }
        })
    }

    let atcForm = document.querySelector('.main-product__item[data-quick-view="false"] .add-to-cart-form, #hype-page-variant-inspect-container .swatches-container')
    if(atcForm) {
        let productId = parseInt(atcForm.getAttribute('data-product-id'));
        window.Branch.product.removeOverlayFromSwatches(productId, parentClass);
    }

    function createSwiperFromSwatches(swatchElementsData) {
        const swiper = document.createElement('div');
        swiper.className = 'swiper swatch-modal__swiper';

        const swiperWrapper = document.createElement('div');
        swiperWrapper.className = 'swiper-wrapper swatch-modal__swiper-wrapper';
        swiper.appendChild(swiperWrapper);

        Object.entries(swatchElementsData).forEach(([swatchHandle, swatchData]) => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide swatch-modal__slide';
            slide.dataset.swatchHandle = swatchHandle;

            const slideInner = document.createElement('div');
            slideInner.className = 'swatch-modal__slide-inner';

            if (swatchData.swatch_image_url) {
                const img = document.createElement('img');
                img.src = swatchData.swatch_image_url.replaceAll('height=100','height=600').replaceAll('width=100','width=600');
                img.alt = swatchHandle;
                slideInner.appendChild(img);
            } else if (swatchData.swatch_gradient_into_second_color) {
                let decodedCss;
                if(swatchData.swatch_tertiary_gradient_color){
                    decodedCss = `background:-moz-linear-gradient(-45deg, ${swatchData.swatch_color_rgb} 0%, ${swatchData.swatch_color_rgb} 50%, ${swatchData.swatch_tertiary_gradient_color_rgb} 51%, ${swatchData.swatch_gradient_into_second_color_rgb} 100%); background: -webkit-linear-gradient(-45deg, ${swatchData.swatch_color_rgb} 0%,${swatchData.swatch_color_rgb} 50%, ${swatchData.swatch_tertiary_gradient_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 100%); background: linear-gradient(135deg, ${swatchData.swatch_color_rgb} 0%,${swatchData.swatch_color_rgb} 50%, ${swatchData.swatch_tertiary_gradient_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='${swatchData.swatch_color}', endColorstr='${swatchData.swatch_gradient_into_second_color}',GradientType=1 );`
                } else {
                    decodedCss = `background:-moz-linear-gradient(-45deg, ${swatchData.swatch_color_rgb} 0%, ${swatchData.swatch_color_rgb} 50%, ${swatchData.swatch_gradient_into_second_color_rgb} 51%, ${swatchData.swatch_gradient_into_second_color_rgb} 51%, ${swatchData.swatch_gradient_into_second_color_rgb} 100%); background: -webkit-linear-gradient(-45deg, ${swatchData.swatch_color_rgb} 0%,${swatchData.swatch_color_rgb} 50%,${swatchData.swatch_gradient_into_second_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 100%); background: linear-gradient(135deg, ${swatchData.swatch_color_rgb} 0%,${swatchData.swatch_color_rgb} 50%,${swatchData.swatch_gradient_into_second_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 51%,${swatchData.swatch_gradient_into_second_color_rgb} 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='${swatchData.swatch_color}', endColorstr='${swatchData.swatch_gradient_into_second_color}',GradientType=1 );`
                }
                slideInner.setAttribute('style', decodedCss);
            } else {
                slideInner.style.backgroundColor = swatchData.swatch_color;
            }

            slide.appendChild(slideInner);
            swiperWrapper.appendChild(slide);
        });

        return swiper;
        }

    function openSwatchModal(target, targetSwatch, targetSwatchGroup) {
        // Swiper lazy-load guard — product templates defer Swiper. Though
        // openSwatchModal fires on user click (which should have loaded
        // Swiper already via the interaction trigger), a fast repeated
        // click can race the load.
        if (typeof window.Swiper === 'undefined') {
            if (typeof window.whenSwiperReady === 'function') {
                window.whenSwiperReady(function(){ openSwatchModal(target, targetSwatch, targetSwatchGroup); });
            }
            return;
        }
        let targetSwatchIndex = 0;
        if(targetSwatch){
            targetSwatchIndex = parseInt(targetSwatch.getAttribute('data-swatch-index'));
        }
        
        const modal = document.createElement('div');
        modal.classList.add('swatch-modal-overlay');

        const modalBox = document.createElement('div');
        modalBox.classList.add('swatch-modal-box');
        modalBox.setAttribute('data-initialized', false);

        const closeBtn = document.createElement('button');
        closeBtn.innerHTML = '&times;';
        closeBtn.classList.add('swatch-modal-close');

        const content = document.createElement('div');
        content.className = "swatch-modal__content"

        let swatchElementsData = {};

        targetSwatchGroup.querySelectorAll('script.swatch-element-data[type="application/ld+json"]').forEach(script => {
            try {
                const data = JSON.parse(script.textContent.trim());

                if (data && data.swatch_handle) {
                const { swatch_handle, ...rest } = data;
                swatchElementsData[swatch_handle] = rest;
                }
            } catch (err) {
                console.error('Failed to parse swatch-element-data JSON:', err, script);
            }
        });


        const swiperElement = createSwiperFromSwatches(swatchElementsData);
        content.appendChild(swiperElement);

        content.innerHTML = `
        ${content.innerHTML}
        <div class="swatch-modal__nav-left swiper-button-prev" data-animate-slide-in="true">
            <svg aria-hidden="false" tabindex="-1" role="presentation" class=" icon icon-chevron" viewBox="0 0 32 32">
                <path fill="#314438" fill-rule="evenodd" clip-rule="evenodd" d="M21.1199 16L7 1.93279L8.94004 0L25 16L8.94004 32L7 30.0672L21.1199 16Z"></path>
            </svg>
        </div>
        <div class="swatch-modal__nav-right swiper-button-next" data-animate-slide-in="true">
            <svg aria-hidden="false" tabindex="-1" role="presentation" class=" icon icon-chevron" viewBox="0 0 32 32">
                <path fill="#314438" fill-rule="evenodd" clip-rule="evenodd" d="M21.1199 16L7 1.93279L8.94004 0L25 16L8.94004 32L7 30.0672L21.1199 16Z"></path>
            </svg>
        </div>
        <div class="swatch-modal__text-container" data-animate-slide-in="true">
            <div class="swatch-modal__swatch-info-container">
                <span class="swatch-modal__swatch-name">${Object.entries(swatchElementsData)[0][1].option_name}:</span>
                <span class="swatch-modal__swatch-value">${Object.entries(swatchElementsData)[0][1].option_value.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span>
            </div>
            <div class="swatch-modal__counter-container">
                <span class="swatch-modal__swatch-index">1</span>/${Object.entries(swatchElementsData).length}
            </div>
        </div>
        `;

        modalBox.appendChild(closeBtn);
        modalBox.appendChild(content);
        modal.appendChild(modalBox);
        document.body.appendChild(modal);


        // Store swatchElementsData globally for resize handler
        window.currentSwatchElementsData = swatchElementsData;

        // Equalize heights of swatch info containers
        updateSwatchModalHeight(modalBox, swatchElementsData);

        var swatchSlider = null;
        if(Object.entries(swatchElementsData).length > 0){
            swatchSlider = new Swiper('.swatch-modal-box .swiper.swatch-modal__swiper', {
                spaceBetween: 0,
                freeMode: false,
                preventClicks : true,
                a11y: false,
                navigation: {
                    prevEl: '.swatch-modal-box .swatch-modal__nav-left',
                    nextEl: '.swatch-modal-box .swatch-modal__nav-right',
                },
                on: {
                    slideChange: function () {
                        document.querySelector('.swatch-modal__swatch-value').innerHTML = `${Object.entries(swatchElementsData)[this.realIndex][1].option_value.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`
                        document.querySelector('.swatch-modal__swatch-index').innerHTML = `${this.realIndex + 1}`
                    },
                    init: function () {
                        this.slideTo(targetSwatchIndex, 0, false);
                        setTimeout(function(){
                            document.querySelectorAll('.swatch-modal-box .swatch-modal__nav-left, .swatch-modal-box .swatch-modal__nav-right').forEach((navArrow) => {
                                navArrow.setAttribute('data-animated', true);
                            });
                            setTimeout(function(){
                                document.querySelector('.swatch-modal__text-container').setAttribute('data-animated', true);
                                setTimeout(function(){
                                    // document.querySelector('.swatch-modal-box').setAttribute('data-initialized', true);
                                }, 250)
                            }, 250)
                        }, 250)
                    },
                },
            })
        }
       
        function closeModal() {
            document.body.removeChild(modal);
            if(swatchSlider){
                swatchSlider.destroy(true, true)
            }
        }

        closeBtn.addEventListener('click', closeModal);
        modal.addEventListener('click', function (e) {
            if (e.target === modal) closeModal();
        });
    }

    document.addEventListener('click', function (event) {
        const target = event.target.closest(`${parentClass} .swatches-container .swatch__search-icon-container`);
        
        if (target) {
            event.preventDefault();
            const targetSwatch = target.closest(`${parentClass} .swatches-container .swatch-element`);
            const targetSwatchGroup = target.closest(`${parentClass} .swatches-container .swatch`);
            openSwatchModal(target, targetSwatch, targetSwatchGroup);
        }
    });

    if(type == 'main' && document.querySelector('body').classList.contains('template-page-hype-erg')){
        let productSwatches = document.querySelectorAll(`${parentClass} .swatch`);
        let selectedVariant = product.selected_variant;
        let productId = product.id;
        window.Branch.product.updateVariantSwatchTitles(productSwatches, selectedVariant, productId);
        window.Branch.product.updateColorSwatchTabsSelectedIndicator(productSwatches, selectedVariant, productId);
    }
}

window.Branch.product.initOkendoStarRendering = function(quickView){
    const POLL_MS = 100;
    const TIMEOUT_MS = 5000;
    const NEW_STAR_EMPTY_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none"><path d="M7.32227 4.59576L7.43652 4.85553L7.71777 4.89069L10.9043 5.28815L8.53125 7.59576L8.33887 7.78326L8.38867 8.04694L9.01172 11.3467L6.25391 9.72369L6 9.57428L5.74609 9.72369L2.9873 11.3467L3.61133 8.04694L3.66113 7.78326L3.46875 7.59576L1.09473 5.28815L4.28223 4.89069L4.56348 4.85553L4.67773 4.59576L6 1.58112L7.32227 4.59576Z" stroke="#314438"/></svg>';
    const NEW_STAR_FILLED_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 9.81758L2.29212 12L3.12013 7.61747L0 4.58375L4.21992 4.05749L6 0L7.78008 4.05749L12 4.58375L8.87987 7.61747L9.70788 12L6 9.81758Z" fill="#314438"/></svg>';

const applyStyling = function(el){
        const countNumber = el.querySelector('.oke-sr-count-number');
        if(countNumber && !countNumber.textContent.endsWith(' ')){
            countNumber.textContent = countNumber.textContent + ' ';
        }
        const labelText = el.querySelector('.oke-sr-label-text');
        if(labelText){
            labelText.textContent = labelText.textContent.replace(/^\s+/, '');
        }
        const starsBg = el.querySelector('.oke-stars-background');
        if(starsBg && starsBg.getAttribute('data-stars-replaced') !== 'true'){
            starsBg.innerHTML = NEW_STAR_EMPTY_SVG.repeat(5);
            // Inline SVGs can soft-wrap at element boundaries even without
            // whitespace between them. Force a single-line layout so the
            // parent's overflow:hidden + width:X% clips the last star into a
            // partial star instead of pushing it onto a second row.
            starsBg.style.whiteSpace = 'nowrap';
            starsBg.setAttribute('data-stars-replaced', 'true');
        }
        const starsFg = el.querySelector('.oke-stars-foreground');
        if(starsFg && starsFg.getAttribute('data-stars-replaced') !== 'true'){
            starsFg.innerHTML = NEW_STAR_FILLED_SVG.repeat(5);
            starsFg.style.whiteSpace = 'nowrap';
            starsFg.setAttribute('data-stars-replaced', 'true');
        }
    };

    const okendoReviewsState = function(container){
        if(!container) return null;

        const metafieldScript = container.querySelector('[data-oke-metafield-data]');
        if(metafieldScript){
            try {
                const data = JSON.parse(metafieldScript.textContent);
                if(data && typeof data === 'object'){
                    const countKey = Object.keys(data).find(function(key){
                        return /review/i.test(key) && /count|total|number|qty/i.test(key);
                    });
                    if(countKey){
                        const count = Number(data[countKey]);
                        if(!isNaN(count)) return count > 0;
                    }
                }
            } catch(e){}
        }

        if(container.querySelector('.oke-sr--hidden')) return false;

        const countNumber = container.querySelector('.oke-sr-count-number');
        if(countNumber && countNumber.textContent.trim()){
            const rendered = Number(countNumber.textContent.replace(/[^\d.]/g, ''));
            if(!isNaN(rendered)) return rendered > 0;
        }

        if(container.querySelector('.oke-sr-stars, .oke-stars-foreground')) return true;

        return null;
    };

    const setStickyHeaderNoReviews = function(el, noReviews){
        const header = el.closest('.sticky-atc__desktop-header');
        if(!header) return;

        if(noReviews){
            header.setAttribute('data-no-reviews', 'true');
        } else {
            header.removeAttribute('data-no-reviews');
        }
    };


    const markParentInitialized = function(el){
        function updateReviewsContainerVisibility(parent) {
            const hasReviews = okendoReviewsState(parent) === true;
            const hasBadge = !!parent.querySelector('.badge-container, .partner-swatch');
            const showContainer = hasReviews || hasBadge;
            parent.setAttribute('data-initialized', showContainer ? 'true' : 'false');
            setStickyHeaderNoReviews(parent, !showContainer);
        }

        const parent = el.closest('.main-product__partner-swatches-reviews-inner-container');
        if(!parent) return;
        updateReviewsContainerVisibility(parent);

    };

    function applyStylingAndMarkInitialized(type, origin){
        let containerSelector = quickView ? '.main-product__item[data-quick-view="true"]' : origin == 'stickyATC' ? '#sticky-atc' : '.main-product__item[data-quick-view="false"]';

        const starRatings = document.querySelectorAll(`${containerSelector} [data-oke-star-rating]`);

        if(!starRatings.length){
            document.querySelectorAll(`${containerSelector} .sticky-atc__desktop-header`).forEach(function(header){
                header.setAttribute('data-no-reviews', 'true');
            });
            return;
        }

        starRatings.forEach(function(el){
            if(okendoReviewsState(el) === false){ setStickyHeaderNoReviews(el, true); }

            const start = performance.now();
            const tick = function(){
                if(el.querySelector('.oke-sr-stars')){
                    if(type == 'regular'){
                        applyStyling(el);
                    }
                    markParentInitialized(el);
                    return;
                }
                if(performance.now() - start > TIMEOUT_MS){
                    markParentInitialized(el);
                    return;
                }
                setTimeout(tick, POLL_MS);
            };
            tick();
        });
    }

    const okendoStylingType = 'regular';

    applyStylingAndMarkInitialized(okendoStylingType);
    if(!quickView){
        applyStylingAndMarkInitialized(okendoStylingType, 'stickyATC');
    }
};

// Calculate and set gallery sticky top position
function calculateGalleryTopPosition() {
    // console.log('calculateGalleryTopPosition')
  const gallery = document.querySelector('.main-product__item[data-quick-view="false"] .main-product__gallery-outer-container');
  if (!gallery) return;

  // Remove styling for mobile
  if (window.innerWidth <= 899) {
    gallery.style.top = '';
    return;
  }

  // Get the gallery height
  const galleryHeight = gallery.offsetHeight;
  const viewportAvailable = window.innerHeight - 153; // 100vh - 153px

  let topValue;

  if (galleryHeight <= viewportAvailable) {
    // If gallery fits in viewport, stick to top
    topValue = 153;
  } else {
    // If gallery is taller, calculate negative offset
    const difference = galleryHeight - viewportAvailable;
    topValue = 153 - difference;
  }

  // Cap top at (153 - 31) so the sticky gallery never sits further down than that.
  if (topValue > 153 - 31) {
    topValue = 153 - 31;
  }

  // Apply the calculated top value
  gallery.style.top = `${topValue}px`;
}

// Initialize gallery position calculation
function initializeGalleryPositioning() {
  // Calculate immediately (before full load)
  calculateGalleryTopPosition();

  // Debounced resize handler
  let resizeTimeout;
  function handleResizeForGalleryPositioning() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      calculateGalleryTopPosition();
    }, 250); // 250ms debounce
  }

  // Set up event listeners
  window.addEventListener('load', calculateGalleryTopPosition);
  window.addEventListener('resize', handleResizeForGalleryPositioning);
}

// Run immediately on DOM ready and set up listeners
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeGalleryPositioning);
} else {
  // DOM already loaded, run immediately
  initializeGalleryPositioning();
}

window.addEventListener("load", function() {
    window.Branch.product.formatSwatches()
    initMainProductSection();
    initEpigraphButtons();
    formatReviewsNumber();
    mainProductWindowWidth = window.innerWidth;
    window.Branch.product.formatPreOrderSwatch();
    window.Branch.product.setUpSwatchTabsEventListener('main')
    checkSizeSwatchesInline();
    window.Branch.product.initOkendoStarRendering(false);
    // Defer one more custom-color swatch width pass after every other init has
    // run and applySwatchTabSizing has set data-scrollable on any open tabs.
    // The earlier passes inside mainProductReformat / applySwatchTabSizing can
    // race the scrollable-state CSS (padding-right: 16px on the inner) and end
    // up sizing the container wide enough that the rightmost swatch sits under
    // the scrollbar. Running once more here guarantees the final value reflects
    // the settled scrollable state.
    setTimeout(function(){
        window.Branch.product.customSwatchContainerResize('.main-product');
    }, 600);
});

var mptof_id;
var mainProductWindowWidth;

window.addEventListener("resize", function() { 
    clearTimeout(mptof_id); 
    mptof_id = setTimeout(function(){
        if (window.innerWidth != mainProductWindowWidth) {
            mainProductWindowWidth = window.innerWidth
            mainProductReformat();

            // Update swatch modal height on resize if modal is open
            const activeModal = document.querySelector('.swatch-modal-box');
            updateSwatchModalHeight(activeModal);
        }
    }, 500); 
}); 
